export default {
  date: {
    formats: {
      default: '%d.%m.%Y',
      short: '%-d %B',
      long: '%-d %B, %Y',
      with_day: '%A, %-d %B %Y',
      without_day: '%-d %B %Y',
    },
    day_names: [
      'søndag',
      'mandag',
      'tirsdag',
      'onsdag',
      'torsdag',
      'fredag',
      'lørdag',
    ],
    abbr_day_names: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
    month_names: [
      null,
      'januar',
      'februar',
      'mars',
      'april',
      'mai',
      'juni',
      'juli',
      'august',
      'september',
      'oktober',
      'november',
      'desember',
    ],
    abbr_month_names: [
      null,
      'jan',
      'feb',
      'mar',
      'apr',
      'mai',
      'jun',
      'jul',
      'aug',
      'sep',
      'okt',
      'nov',
      'des',
    ],
    order: [':day', ':måned', ':year'],
  },
  number: {
    format: {
      separator: '.',
      delimiter: ',',
      precision: 3,
      round_mode: 'default',
      significant: false,
      strip_insignificant_zeros: false,
    },
    currency: {
      format: {
        format: '%u%n',
        unit: '$',
        separator: '.',
        delimiter: ',',
        precision: 2,
        significant: false,
        strip_insignificant_zeros: false,
      },
      EUR: '€',
      USD: 'US$',
      CAD: 'cad',
      AUD: 'aud',
      GBP: '£',
      DKK: 'kr',
      NOK: 'kr',
      SEK: 'kr',
    },
    percentage: {
      format: {
        delimiter: null,
        format: '%n%',
      },
    },
    precision: {
      format: {
        delimiter: null,
      },
    },
    human: {
      format: {
        delimiter: null,
        precision: 3,
        significant: true,
        strip_insignificant_zeros: true,
      },
      storage_units: {
        format: '%n %u',
        units: {
          byte: 'B',
          kb: 'KB',
          mb: 'MB',
          gb: 'GB',
          tb: 'TB',
          pb: 'PB',
          eb: 'EB',
        },
      },
      decimal_units: {
        format: '%n %u',
        units: {
          unit: null,
          thousand: 'Tusen',
          million: 'Million',
          billion: 'Milliard',
          trillion: 'Billion',
          quadrillion: 'Kvadrillion',
        },
      },
    },
    nth: {
      ordinals: {},
      ordinalized: {},
    },
  },
  datetime: {
    distance_in_words: {
      half_a_minute: 'et halvt minutt',
      less_than_x_seconds: {
        one: 'mindre enn 1 sekund',
        other: 'mindre enn %{count} sekunder',
        few: 'mindre enn %{count} sekunder',
        many: 'mindre enn %{count} sekunder',
      },
      x_seconds: {
        one: '1 sekund',
        other: '%{count} sekunder',
        few: '%{count} sekunder',
        many: '%{count} sekunder',
      },
      less_than_x_minutes: {
        one: 'mindre enn 1 minutt',
        other: 'mindre enn %{count} minutter',
        few: 'mindre enn %{count} minutter',
        many: 'mindre enn %{count} minutter',
      },
      x_minutes: {
        one: '1 minutt',
        other: '%{count} minutter',
        few: '%{count} minutter',
        many: '%{count} minutter',
      },
      about_x_hours: {
        one: 'omtrent 1 time',
        other: 'omtrent %{count} timer',
        few: 'omtrent %{count} timer',
        many: 'omtrent %{count} timer',
      },
      x_days: {
        one: '1 dag',
        other: '%{count} dager',
        few: '%{count} dager',
        many: '%{count} dager',
      },
      about_x_months: {
        one: 'omtrent 1 måned',
        other: 'omtrent %{count} måneder',
        few: 'omtrent %{count} måneder',
        many: 'omtrent %{count} måneder',
      },
      x_months: {
        one: '1 måned',
        other: '%{count} måneder',
        few: '%{count} måneder',
        many: '%{count} måneder',
      },
      about_x_years: {
        one: 'omtrent 1 år',
        other: 'omtrent %{count} år',
        few: 'omtrent %{count} år',
        many: 'omtrent %{count} år',
      },
      over_x_years: {
        one: 'mer enn 1 år',
        other: 'mer enn %{count} år',
        few: 'mer enn %{count} år',
        many: 'mer enn %{count} år',
      },
      almost_x_years: {
        one: 'nesten 1 år',
        other: 'nesten %{count} år',
        few: 'nesten %{count} år',
        many: 'nesten %{count} år',
      },
      x_years: {
        one: '1 år',
        other: '%{count} år',
      },
      x_weeks: {
        one: '1 uke',
        other: '%{count} uker',
        few: '%{count} uker',
        many: '%{count} uker',
      },
      x_hours: {
        one: '1 time',
        other: '%{count} timer',
      },
    },
    prompts: {
      year: 'år',
      month: 'måned',
      day: 'dag',
      hour: 'time',
      minute: 'minutt',
      second: 'sekunder',
    },
  },
  'custom-wallpaper': {
    'aria-title': 'Wallpaper',
    'aria-label': 'Set Wallpaper',
    'aria-author': 'author:',
  },
  page: {
    plus: {
      button: {
        text: 'Oppgrader til Pro',
      },
    },
    profile: {
      wallpapers: {
        best_1: 'Opptil fem forskjellige bilder',
        best_2: 'JPEG eller PNG',
        best_3: 'Opptil %{size}',
        best_4: '%{resolution} piksler eller mer',
        best_5: 'Ingen GIF-er eller filmer (beklager)',
        best_title: 'De viktige sakene:',
        text: 'Gi deg selv eller merkevaren din oppmerksomheten, med opptil fem roterende filmer eller bilder.',
        best_five: '%{videoResolution} piksler for videoer',
        best_four: '%{resolution} piksler for bilder',
        best_one: 'Opptil fem filmer eller bilder',
        best_six:
          'Bakgrunner roterer hvert %{rotationInterval} sekund, så filmer som er lengre enn %{rotationInterval} sekunder blir avbrutt',
        best_three: '%{size} maksimalt per video/bakgrunn',
        best_two: 'JPEG, PNG eller MP4',
        notice:
          "Kan vi få en trommevirvel – videobakgrunner har ankommet! <a href='/profile'>Nå kan du gjøre bakgrunnen din til en video</a>.",
      },
      upsell: {
        benefit_one_alt: 'Få din egen WeTransfer-side',
        heading_alt: 'Lever arbeidet ditt med stil',
        benefit_one: 'Få ditt eget WeTransfer-domene',
        benefit_three: 'Utform dine egne e-poster for overføringer',
        benefit_two:
          'Vis frem dine egne bakgrunner når folk laster ned filene dine',
        button: {
          action: 'Jeg vil vite mer',
        },
        heading: 'Vis frem merkevaren din med WeTransfer Pro',
      },
      branding: {
        headline:
          '<strong>Send med den beste.</strong> Gjør et godt inntrykk hver gang noen laster ned filene dine.<br /> <strong>Motta på en enkel måte.</strong> Som en del av planen din, kan hvem som helst laste opp filer til deg.',
        protip: {
          text: '<strong>Profftips:</strong> Ber du om en overføring fra noen? Del en spesiell lenke for å forhåndsutfylle beskrivelsen for dem.',
          link: 'Les mer',
        },
      },
      pagename: 'Profilinnstillinger',
      'onboarding-step-two':
        "Gi filene dine den stilriktige presentasjonen de fortjener, sett personlig preg på WeTransfer-profilen din og beundre den nye looken din på <a href='%{href}'>%{domain}</a>.",
      email_backgrounds: 'E-postbakgrunner',
      sent_you_files: 'har sendt deg noen filer',
      email_background_instruction_with_spec:
        'Legg til et bakgrunnsbilde som gjør at e-postene dine for overføringer skiller seg ut.  \nResultatet blir best med bilder på %{resolution} piksler (bilder som er større enn dette, blir beskåret). Maks filstørrelse er %{size}.   ',
      receiving: 'E-postadresse for profil',
      choose_wallpapers: 'Bakgrunner',
      'step-one-banner':
        'For å starte velger du først en URL-adresse til WeTransfer-siden. Du kan alltids endre dette senere.',
      description: {
        pro: 'Med WeTransfer-siden din kan du gjøre et godt inntrykk hver gang folk laster ned filene dine. Det er også hit hvem som helst kan sende overføringer på 200 GB, som en del av WeTransfer Pro-pakken.',
        premium:
          'Med WeTransfer-siden din kan du gjøre et godt inntrykk hver gang folk laster ned filene dine. Det er også hit hvem som helst kan sende overføringer til deg uten begrensninger på filstørrelse, som en del av WeTransfer Premium-pakken.',
      },
      'instructions-1':
        'Endre navnet og URL-adressen din så mange ganger du vil.',
      'instructions-2':
        'Når du har valgt en ny URL-adresse, blir siden din oppdatert med en gang.',
      title: 'Rediger siden din',
      profile_url: 'Profil-URL',
    },
    payment: {
      never_actived_retry:
        'Kontoen din er ikke aktiv ennå. Fullfør registreringen for å komme i gang med <a href="/payment/retry">%{planName}</a>',
      pagename: 'Abonnement og betaling',
      autorenew_heading: 'Betalingsinformasjon',
      autorenew_notice:
        '%{planName}-abonnementet ditt på %{deal} fornyes automatisk %{autorenewal_attempt}.',
      will_expire_notice:
        "Pro-planen din <span class='payment__notice'>utløper om %{daysBetween} dager</span>. Forny kontoen din nå eller konfigurer automatisk fornyelse.",
      never_actived_notice:
        'Kontoen din er ikke aktiv ennå. <a href="/payment/retry">Fullfør registreringen for å komme i gang med Pro.</a>',
      manual_renewal_expiry_notice: 'Pro-kontoen din utløper %{expiry}.',
      to_checkout: 'Gå til kassa',
      updating: 'Oppdaterer …',
      yes_disable: 'Ja, fortsett',
      review_billing_link: 'Vil du oppdatere betalingsmåten din?',
      autorenew_failed:
        "Pro-abonnementet ditt på %{deal}/%{period} <span class='payment__notice'><strong>utløper om %{daysBetween} dager</strong>. Kontoen kan ikke fornyes automatisk, så gjør dette manuelt før <strong>%{expiry}</strong>.</span>",
      confirm_disable_autorenew:
        'Er du sikker på at du vil stoppe automatisk fornyelse?',
      disable_autorenewal: 'Stopp automatisk fornyelse',
      enable_autorenewal: 'Aktiver automatisk fornyelse',
      renew_now: 'Forny nå',
      subscription_expired: 'Pro-abonnementet ditt er utløpt.',
      cancel_heading: 'På tide å gå videre?',
      cancel_info:
        'Vi skjønner, slikt skjer. Når du avbryter abonnementet ditt, lagrer vi filene dine i 30 dager til (nei, ikke under puten vår – vi er ikke rare), bare i tilfelle du la igjen noe. Du kan også åpne abonnementet ditt igjen når som helst.',
      cancel_info_subscription:
        'Vi skjønner, slikt skjer. Når du avbryter abonnementet ditt, vil du kunne bruke Pro-kontoen din frem til %{subscriptionExpiryDate} . Etter dette lagrer vi filene dine i ytterligere 30 dager (nei, ikke under puten vår – vi er ikke rare), bare i tilfelle du la igjen noe. Du kan også åpne abonnementet ditt igjen når som helst.',
      cancel_now: 'Avbryt abonnement',
      cancelling: 'Avbryter …',
      confirm_cancel_subscription:
        'Er du sikker på at du ønsker å avbryte abonnementet ditt?',
      confirm_reactivate_subscription:
        'Strålende valg! Bare ett klikk til, for å reaktivere betalingsmetode.',
      manual_renewal_in_future_notice:
        'Pro-abonnementet på %{deal}/%{period} utløper om %{daysBetween} dager. Du kan fornye kontoen manuelt etter %{manual_renewal_available_at}, eller aktivere automatisk fornyelse nå.',
      reactivate_heading: 'La oss starte på nytt.',
      reactivate_content_top_pro:
        'Du kan reaktivere %{planName}-abonnementet ditt, og da er det som om du aldri hadde sagt det opp. Eller du kan velge å oppgradere til WeTransfer Premium:',
      reactivate_content_top_premium:
        'Du kan reaktivere %{planName}-abonnementet ditt, og da er det som om du aldri hadde sagt det opp.',
      reactivate_content_bottom_pro:
        'Hvis du oppgraderer til Premium, blir du belastet %{upfront_payment}, og så kan du starte med WeTransfer Premium med en gang. Det nye abonnementet til %{recurring_payment} per %{interval} blir fornyet %{recurring_date}.',
      reactivate_pro: 'Reaktiver Pro',
      reactivate_premium: 'Reaktiver Premium',
      reactivate_upgrade_to_premium: 'Oppgrader til Premium',
      reactivating: 'Reaktiverer …',
      subscription_cancelled:
        'Abonnementet ditt har blitt avbrutt, og utløper automatisk om %{daysBetween} dager.',
      subscription_reactivate_expired_notice:
        'Pro-kontoen din har blitt avbrutt.',
      subscription_reactivate_notice_pro:
        '%{planName}-abonnementet er avsluttet og utløper om %{daysBetween} dager.',
      subscription_reactivate_notice_premium:
        '%{planName}-abonnementet er avsluttet og utløper om %{daysBetween} dager.\nHar du ombestemt deg? Ingen grunn til panikk – det er lett å komme i gang igjen.',
      subscription_reactivate_notice_trial_before:
        '%{planName}-abonnementet er avsluttet og utløper om %{daysBetween} dager.\nDu kan fortsette å bruke prøveperioden av WeTransfer Premium til abonnementet utløper.',
      subscription_reactivate_notice_trial_after:
        '%{planName}-abonnementet er avsluttet og utløper om %{daysBetween} dager.\nDu kan fortsette å bruke prøveperioden av WeTransfer Premium til %{trialExpiryDate}.',
      update_method_link: 'Oppdater betalingsinformasjon',
      autorenew_notice_teams:
        '%{planName}-abonnementet ditt på %{deal} fornyes automatisk for teamet ditt på %{number_of_members} medlemmer %{autorenewal_attempt}.',
      cancellation_cta: 'Avbryt abonnement',
      cancellation_heading: 'Trenger du ikke lenger fordelene fra %{planName}?',
      cancellation_heading_trial: 'Avbryt abonnement',
      cancellation_text:
        'Dersom du avslutter abonnementet ditt, vil du kunne bruke Pro-funksjonene frem til %{subscriptionExpiryDate}. Etter dette omgjøres WeTransfer Pro-kontoen din til en gratiskonto, og de aktive overføringene dine utløper 28 dager senere.',
      cancellation_text_item_1: 'Sende opptil %{transfer_limit}',
      cancellation_text_item_2: 'Passordbeskytte overføringer',
      cancellation_text_item_3:
        'Administrere og lagre %{storage_limit} med overføringer',
      cancellation_text_item_4:
        'Ha din egen URL-adresse og tilpassede Pro-side',
      cancellation_text_item_heading:
        'En gratiskonto lar deg bare overføre opptil %{free_size_limit} per overføring. Du vil ikke lenger kunne:',
      cancellation_text_new:
        'Hvis du avslutter abonnementet nå, kan du bruke %{planName} til %{subscriptionExpiryDate}. Etter det blir du nedgradert til gratisabonnementet.<br /><br />Vær obs på at eventuelle eksisterende overføringer utløper senest 28 dager etter at abonnementet er utløpt.',
      cancellation_text_teams:
        'Hvis du avslutter abonnementet ditt nå, kan du og teamet bruke %{planName} til %{subscriptionExpiryDate}.<br /><br />Etter det kan ikke du og teammedlemmene sende filoverføringer og lage presentasjonslysbilder eller tavler sammen. Du blir nedgradert til gratisabonnementet, og du kan bare logge på din egen WeTransfer-konto.<br /><br />Vær obs på at eventuelle eksisterende overføringer utløper senest 28 dager etter at abonnementet er utløpt.',
      premium_trial: {
        feature_list_item_1: 'Ingen størrelsesbegrensninger på overføringer',
      },
      premium_upgrade: {
        cta: 'Bytt til Premium',
        description:
          'Du blir belastet med %{upfront_payment}, så kan du begynne med WeTransfer Premium umiddelbart. Det nye abonnementet ditt på %{recurring_payment} i %{interval} blir fornyet den %{recurring_date}.',
        feature_list_item_1: 'Send overføringer uten begrenset filstørrelse',
        feature_list_item_2: 'Ubegrenset lagringsplass',
        feature_list_item_3: 'Ubegrensede portaler og gjennomganger',
        feature_list_item_4: '%{storageLimit} med lagringsplass',
        heading: 'Har du lyst til å oppgradere abonnementet?',
      },
      unpaid_invoices: {
        heading: 'Du har ubetalte fakturaer',
        item: {
          issued_on: 'Utstedt',
          pay_invoice: 'Betal faktura',
          pending_invoice: 'Venter …',
        },
        subheading:
          'Det ser ut til at det var et problem med de tidligere betalingene dine. Betal eventuelle utestående fakturaer, ellers kan Pro-abonnementet ditt bli kansellert.',
        subheading_2:
          'Hvis du har fakturaer på vent, behøver du ikke å gjøre noe – vi prøver igjen om et par dager, og så snart betalingen er vellykket, er alt i orden.',
      },
      upgrade_cta: 'Oppgrader',
      app_subscription_banner: {
        title: 'Du abonnerer fra %{app_name}',
        content:
          'Logg på %{app_name}-kontoen fra telefonen eller datamaskinen din for å se eller administrere abonnementet.',
        go_to: 'Gå til',
        learn_more: 'Finn ut mer',
      },
    },
    'payment_cancel-verify': {
      cancellation_cta: 'Avbryt abonnement',
      cancellation_disclaimer:
        '*Pass på! De aktive overføringene dine utløper ikke mer enn 28 dager etter at kontoen din blir nedgradert.',
      'current-plan': 'Gjeldende abonnement',
      'free-forever': 'Gratis i all evighet',
      'free-usp-1': 'Send opptil 2 GB',
      'free-usp-2': 'Ingen lagringskapasitet',
      'free-usp-3': 'Overføringer utløper etter 7 dager*',
      'heading-free': 'WeTransfer',
      'heading-pro': 'WeTransfer Pro',
      intro:
        'Dersom du avslutter abonnementet ditt nå, vil du kunne fortsette å bruke WeTransfer Pro frem til <b>%{expiration_date}</b>. Etter dette nedgraderes du til en gratis WeTransfer-konto – som fremdeles er rimelig bra.',
      pagename: 'Trenger du ikke lenger fordelene fra Pro?',
      'pro-usp-1': 'Send og motta opptil %{transfer_limit}',
      'pro-usp-2': '1 TB lagringskapasitet',
      'pro-usp-3': 'Avgjør selv når overføringer utløper',
      'pro-usp-4':
        '<p>Din egen <a href="/profile?utm_source=pro_pass&utm_medium=usp_4_link&utm_campaign=cancel_verify">Pro-side</a></p>',
      'pro-usp-5':
        '<a href="https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=usp_5_link&utm_campaign=cancel_verify">Lås opp Paste® Pro og Collect Pro</a>',
    },
    payment_cancel: {
      info_with_end_date:
        '<p>Du har nå avsluttet abonnementet ditt, og blir nedgradert til en gratis WeTransfer-konto etter <b>%{ends_at}.</b></p>\n<p>Vennligst fortell oss hvorfor du forlater oss, så vi kan forbedre WeTransfer med deg i tankene.</p>',
      reason_header: 'Vi er lei oss for at du forlater oss',
      cancel: 'Gå tilbake',
      info: 'Fortell oss hvorfor, slik at vi kan fortsette å forbedre WeTransfer Pro med tanke på deg.',
      pagename: 'Før du forlater oss',
      yes_disable: 'Ja, gjør det',
    },
    payment_failed: {
      selected_product: 'Én %{duration} med %{planTier}',
      change: 'Oppdater',
      complete_order: 'Fullfør bestillingen',
      description:
        'Gå gjennom opplysningene du har lagt inn og fullfør bestillingen',
      description_error:
        'Noe gikk galt. Kontroller opplysningene du har lagt inn og gå til kassa',
      description_refused:
        'Betalingen ble ikke behandlet. Kontroller betalingsinformasjonen din og prøv igjen',
      discount: 'Rabatt',
      product_description: '1 %{duration} med WeTransfer Pro',
      title: 'Du er nesten i mål!',
      total: 'Totalt',
      vat: 'MVA',
      your_details: 'Din informasjon',
      your_order: 'Din bestilling',
      title_error: 'Hmmm … Det er ut som om noe gikk galt',
      title_refused: 'Hmmm … det ser ut som om noe gikk galt',
      payment_status_message:
        'Betalingen var vellykket, men noe gikk galt, og vi kunne ikke oppdatere abonnementet ditt automatisk. <a href="https://wetransfer.zendesk.com/hc/en-us/requests/new" rel="external">Ta kontakt med støtteteamet</a>',
    },
    payment_methods: {
      billed_now: 'Fakturert nå',
      info_content: {
        cancel_bullet:
          'Slapp av, du finner alternativet til å avbryte under Kontoinnstillinger > Betaling.',
        initial_payment_bullet:
          'Etter den første betalingen blir du belastet med %{price} %{interval} (med mindre du avbryter abonnementet ditt, men det du kommer ikke til å gjøre, ikke sant? Ikke sant!?)',
        update_payment_bullet:
          'Du har alltid muligheten til å oppdatere betalingsopplysningene dine og/eller fakturainformasjonen før neste betaling forfaller.',
        month:
          '– Etter den første betalingen blir du belastet med %{price} hver måned (med mindre du velger å avslutte Pro-abonnementet – men det gjør du vel ikke? Gjør du vel?!)\n – Ingen fare, du finner muligheten til å avslutte i Kontoinnstillinger > Betaling.\n– Du kan alltid oppdatere betalingsmetoden og/eller bedriftsdetaljene før neste betaling forfaller.',
        year: '- Etter første betaling, belastes du %{price} årlig (med mindre du ønsker å avslutte Pro-abonnementet ditt – men det kommer ikke til å skje, gjør du vel? Gjør du?!)\n– Du kan når som helst avslutte ved å gå til Kontoinstillinger > Betaling.\n– Du kan alltid oppdatere betalingsmetode og/eller firmadetaljer før neste betaling forfaller.',
      },
      payment_cta: 'Fullfør betalingen',
      payment_term: {
        monthly: 'en gang i måneden',
        yearly: 'en gang i året',
      },
      payment_title: 'Betaling',
      plan_details: {
        premium: 'WeTransfer Premium',
        pro: 'WeTransfer Pro',
        month: 'Månedlig',
        year: 'Årlig',
      },
      subtotal: 'Delsum',
      legislation_text:
        'Ich fordere und stimme ausdrücklich zu, dass Sie mit der von mir bestellten Dienstleistung vor Ablauf der Widerrufsfrist beginnen. Mir ist bekannt, dass mein Widerrufsrecht mit vollständiger Vertragserfüllung erlischt.*',
      legislation_footer:
        '* Hier finden Sie die <a href="/legal/terms?overrideLanguage=de" target="_blank">Nutzungsbedingungen</a> und <a href="/documents/Datenschutz_und_Cookierichtlinie.pdf" target="_blank">Datenschutz- und Cookie-Erklärung.</a>',
      your_payment_method: 'Din betalingsmetode',
      bancontact: 'Bancontact',
      card: 'Kredittkort',
      card_cvc: 'CVC',
      card_expiration: 'MM/ÅÅ',
      card_name: 'Kortholders navn',
      card_number: 'Kortnummer',
      complete_payment: 'Fullfør betalingen din',
      creditcard: 'Kredittkort',
      discount: 'Rabatt',
      do_not_refresh: 'Ikke oppdater eller lukk denne siden',
      ideal: 'iDEAL',
      ideal_info:
        'iDEAL er en nederlandsk betalingsmetode, hvor forbrukeren kan bruke sin egen bank for å utføre betalingen.',
      info: 'Oppdatering av betalingsmetoder',
      payment_in_progress: 'Betalingen din blir behandlet …',
      paypal: 'PayPal',
      plan_name: 'WeTransfer Pro',
      price_period: {
        month: '/måned',
        year: '/år',
      },
      select_bank: 'Velg din bank',
      select_country: 'Velg land',
      sofort: 'SOFORT',
      tax: 'MVA',
      title: 'Velg betalingsmetode',
      total: 'Totalt',
    },
    projects: {
      actions: {
        go_back: 'Alle prosjekter',
        discard: 'Forkast endringene',
        edit: 'Rediger',
        remove_transfer:
          'Vil du slette denne overføringen? Filer blir fjernet fra dette prosjektet og sendte overføringer.',
        save: 'Lagre',
        share: 'Del',
      },
      transfer_actions: {
        download: 'Last ned',
      },
      added_at: 'på %{timeOfDay}',
      clipboard_modal: {
        copy_link: 'Kopier kobling',
        link_copied: 'Kobling kopiert til utklippstavlen',
        content_label: 'Kopier lenken til dette prosjektet',
        list_item_1: 'Kun tilgang til nedlasting og visning',
        list_item_2: 'Koblingen forblir den samme for alltid',
        title: 'Del prosjektet',
      },
      content: {
        empty_state:
          'Prosjektet er for øyeblikket tomt. Kom i gang ved å legge til noen filer for å starte prosjekttidslinjen.',
      },
      logo_title: 'Gå tilbake til wetransfer.com',
      logo_tooltip_caption: 'Tilbake til WeTransfer',
      timestamp: 'for %{timeAgo} siden',
      chat: {
        owner_button_label: 'Psst … snakk med oss',
        owner_offline_greeting:
          'For øyeblikket er vi ikke på nett, men fortell oss hva du har problemer med, så kontakter vi deg innen én virkedag.',
        owner_online_greeting:
          'Fortell oss hva du har problemer med, så kontakter vi deg igjen så snart vi kan',
        receiver_button_label: 'Spørsmål? Vi er her for å hjelpe',
        receiver_offline_greeting:
          'Fortell oss hva du har problemer med, så kontakter vi deg igjen så snart vi kan.',
        receiver_online_greeting:
          'Fortell oss hva du har problemer med, så kontakter vi deg igjen så snart vi kan.',
      },
      created_by: 'Opprettet av %{user}',
      created_by_fallback: 'Opprettet',
      deliverable_clipboard_modal: {
        content_label: 'Kopier koblingen til denne leveransen',
        info: 'Andre vil også kunne se prosjektet ditt',
        title: 'Del leveransen',
      },
      deliverables: {
        add_deliverable: 'Add a deliverable',
        add_files: 'Add files',
        cancel_upload: 'Cancel this upload?',
        clear_all_files_option: 'Clear all files',
        create_deliverable: {
          input_placeholder_0: 'Rough illustrations',
          input_placeholder_1: 'Brand guidelines',
          input_placeholder_2: 'Royalty-free SFX samples',
          input_placeholder_3: 'Color corrected video',
          input_placeholder_4: 'Voiceover recordings from my closet',
          input_placeholder_5: 'Quick sketches for quick approval',
          input_placeholder_6: '10,000 storyboard options',
          input_placeholder_7: 'The first video cut is the deepest',
          input_placeholder_8: 'Raw photos (for selection)',
          input_placeholder_9: 'My music reco (plus five lousy other options)',
        },
        create_deliverable_cancel: 'Cancel',
        create_deliverable_label: 'What will you deliver?',
        create_deliverable_save: 'Save',
        date: {
          updated_today: 'Updated today',
          updated_yesterday: 'Updated yesterday',
        },
        delete_option: 'Delete',
        deliverable_cleared:
          'Cleared all files from <strong><u>%{deliverableName}</u></strong>',
        deliverable_deleted:
          '<strong><u>%{deliverableName}</u></strong> has been deleted',
        deliverable_label: 'Deliverable',
        edit_option: 'Edit',
        edit_prompt: 'Rename this deliverable or add a description',
        empty_deliverable_state: 'No files yet. Coming soon',
        more_option: 'More',
        no_deliverables: {
          heading: 'Add a deliverable<br />to upload files',
        },
        no_deliverables_not_project_owner: {
          heading:
            '%{projectOwner} hasn’t added any deliverables for this project yet.',
        },
        processing_deliverable_state: 'Processing...',
        rename_option: 'Rename',
        share_option: 'Share',
        upload_cancel: 'Cancel',
        upload_files: 'Upload files',
        uploading: 'Uploading...',
        uploading_paused: 'Upload paused...',
        view: 'View',
      },
      errors: {
        blank: 'Dette er ikke prosjektet du leter etter …',
        limit:
          'Potensialet ditt er uendelig, men du har nådd grensen for antall tegn',
        required:
          'Du vet hvordan dette er. Du kan ikke hoppe over å fylle ut dette',
      },
      event: {
        project_created_byline:
          'Legg til noen filer for å vise hva du jobber med.',
        project_created_title: 'Starten på prosjektet',
      },
      file_count: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      just_now: 'akkurat nå',
      labels: {
        description: 'Beskrivelse',
        name: 'Navn',
        new_name: 'Gi navn til prosjektet',
      },
      logo: {
        cta: 'Legg til en logo',
        errors: {
          dimensions:
            'Logoen din er mindre enn 220 x 220 piksler. Prøv et større bilde',
          general: 'Hmm, noe gikk galt. Gjør et nytt forsøk',
          size: 'Logoen din er større enn 5 MB. Prøv en mindre fil',
          type: 'Logoen er hverken JPEG, GIF eller PNG. Prøv et annet bilde',
        },
        instructions:
          'Logoen kan være opptil 5 MB. JPEG-er og GIF-er er greit, men PNG-er med gjennomsiktig bakgrunn fungerer best',
        'instructions-title': 'Vis frem varemerket ditt',
      },
      name_modal: {
        content_label: 'Gi navn eller nytt navn på prosjektet ditt',
        input_placeholder_0: 'Definitivt en Cannes Lion',
        input_placeholder_1: 'En kur mot forkjølelse',
        input_placeholder_2: 'Den perfekte forbrytelsen',
        input_placeholder_3: 'I Write Songs Not Titles',
        input_placeholder_4: 'Prisvinnende idé',
        input_placeholder_5: 'Helt ny merkevarekampanje',
        input_placeholder_6: 'Verdensherredømme',
        save: 'Lagre',
        text: 'Beskriv hva du jobber med.',
        title: 'Gi navn til prosjektet',
      },
      new_project_label: 'Start et nytt prosjekt',
      noticebar: {
        'button-cancel': 'Avbryt',
        'button-clear-all-files': 'Fjern alt',
        'button-close': 'Lukk',
        'button-delete': 'Slett',
        'button-no': 'Nei',
        'button-share': 'Del',
        'button-yes': 'Ja',
        'confirm-cancel': 'Vil du avbryte overføringen?',
        'confirm-clear-files-deliverable':
          'Vil du fjerne alle filer fra <strong><u>%{deliverableName}</u></strong>?',
        'confirm-complete':
          'Opplasting fullført! Fortell alle at du har lagt til flere filer.',
        'confirm-delete-deliverable':
          'Vil du slette <strong><u>%{deliverableName}</u></strong> og eventuelle filer du har lastet opp til det?',
        'confirm-first-complete':
          'Opplasting fullført! Del dette prosjektet for at filene dine skal lastes ned.',
        deliverable_not_found_error:
          'Hmm, det ser ut til at den leveransen er slettet',
        general_error: 'Å nei, noe gikk galt. Prøv igjen.',
      },
      'onboarding-promise': {
        description:
          'Beskriv alt arbeidet du skal levere for et prosjekt og effektiviser måten du deler på. Lag en liste over leveranser, og legg deretter til filer underveis – du trenger ikke forskjellige nedlastingskoblinger mer.',
        title: 'Start i rute for å holde deg i rute',
      },
      onboarding: {
        banner:
          'Obs! Du er en av de få utvalgte med tilgang til Prosjekter mens det ennå er i byggefasen (og under forbedring). Det kan være vi tar kontakt med deg for å få tilbakemeldinger.',
      },
      pagename: 'Prosjekter',
      placeholders: {
        description: 'Gi prosjektet en kort beskrivelse',
        loading: 'Laster …',
      },
      project: {
        notification: {
          name_saved: 'Navnet er lagret! Prosjektet høres ut som en vinner.',
        },
      },
      share_button_label: 'Del',
      unnamed_project_title: 'Prosjekt uten navn',
      watch_video: 'Se video',
    },
    transfer: {
      display_name_fallback: 'Overføring uten tittel',
      does_not_expire: 'ingen <u>utløpsdato</u>',
      expires_in: 'Utløper om <span>%{time}</span>',
      downloaded_at: 'Lastet ned %{date} klokka %{time}',
      not_downloaded: 'Ikke lastet ned ennå',
      email_bounced: 'E-postadressen du sendte til, funket ikke',
      count_files: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      sent_datetime: 'Sendt %{date} klokka %{time}',
      never_expires: 'Ingen utløpsdato',
      and_more: 'Legg til %{count} til',
      read_more: 'mer',
      copy_link: 'kopier kobling',
      message: 'Melding',
      total_downloads: 'Nedlastinger totalt',
      sent_to_recipients: {
        one: 'Sendt til %{count} person',
        other: 'Sendt til %{count} personer',
      },
      no_transfers: 'Alle overføringene du sender, blir vist her',
      add_first_description:
        'Kontroller nedlastingsstatus, eller rediger, videresend eller slett dem',
      mobile: {
        download: 'Last ned alle filer',
        remove: 'Slett overføring',
      },
      delete_datetime: 'Filer slettet %{date} klokken %{time}',
      detail: {
        plus_download_stats:
          'Få Pro for å holde oversikt over hvor mange ganger overføringene dine har blitt lastet ned.',
        plus_password_expiration:
          'Få Pro for å angi passord og utløpsdatoer på overføringene dine.',
        plus_transfer_actions:
          'Få Pro for å administrere overføringene dine og slette dem når som helst.',
        title: 'Overføringsinformasjon',
      },
      download_status_email: '%{count} av %{total} personer',
      download_status_email_text: {
        zero: 'Ikke lastet ned ennå',
        one: '%{count} av %{total} personer',
        other: '%{count} av %{total} personer',
      },
      download_status_link: {
        one: 'én gang',
        other: '%{count} ganger',
      },
      download_status_link_text: {
        zero: 'Ikke lastet ned ennå',
        one: '1 gang',
        other: '%{count} ganger',
      },
      sent_moment: 'Sendt %{moment}',
      total_downloads_tooltip:
        'Er det annerledes enn du hadde ventet? Vi har nettopp gjort en liten forandring. Dette tallet viser bare fullførte nedlastinger.',
      display_name: {
        label: 'Tittel',
        label_mobile:
          'Legg til en tittel, slik at folk vet hva de finner i overføringen din',
      },
      download_status_received_text: {
        zero: 'Ikke lastet ned ennå',
        one: 'Lastet ned',
        other: 'Lastet ned',
      },
      edit_display_name: {
        cancel: 'Avbryt',
        save: 'Lagre',
        title: 'Tittel',
      },
      received_datetime: 'Mottatt %{date} klokka %{time}',
      received_from: 'Mottatt fra',
      received_moment: 'Mottatt %{moment}',
      teams: {
        received_by: 'Mottatt av',
        self: 'meg',
        sent_by: 'Sendt av',
      },
      title: 'Tittel',
      set_password: {
        added: 'Lagt til',
        change: 'Endre',
        remove: 'Fjern',
        description:
          'Angi et passord for å kontrollere hvem som har tilgang til denne overføringen.',
        remove_warning:
          'Vil du fjerne passordbeskyttelsen fra denne overføringen?',
        yes_remove: 'Ja, fjern den',
      },
      set_expiration: {
        description:
          'Angi en utløpsdato for å begrense tilgangen til denne overføringen.',
        label: 'Utløper',
      },
      anon_upsell_no_account:
        '<a href="%{href}">Registrer deg</a> gratis for å redigere eller spore nedlastinger for denne overføringen før den utløper.',
      anon_upsell_found_account:
        '<a href="%{href}">Logg på</a> for å redigere eller spore nedlastinger for denne overføringen før den utløper.',
      anon_upsell_no_account_with_button:
        'Du kan redigere denne overføringen før den utløper, ved å opprette en konto.',
      create_free_account: 'Opprett en gratiskonto',
    },
    transfers: {
      space_used_unlimited: ' %{space} av lagringsplass brukt',
      pagename: 'Overføringer',
      search: 'søk etter filnavn',
      search_results: {
        one: '%{count} søkeresultat',
        other: '%{count} søkeresultater',
        none: 'Ingen resultater',
        retry:
          'Ser ut til at vi ikke fant en overføring som samsvarte med søket ditt – prøv på nytt.',
      },
      space_used: '%{space} av %{totalSpace} er brukt',
      selected_text: {
        one: '%{count} overføring valgt (%{size})',
        other: '%{count} overføringer valgt (%{size})',
      },
      last_7_days: 'Sendt i løpet av de siste 7 dagene',
      over_7_days: 'Sendt for mer enn 7 dager siden',
      sort_on: 'Sorter etter:',
      size: 'Størrelse',
      name: 'Navn',
      date: 'Dato',
      delete: 'Slett',
      download: 'Last ned',
      forward: 'Videresend',
      remove: 'Slett',
      select: 'Velg',
      copy_link: 'Kopier kobling',
      sent_time_ago: 'Sendt for %{timeAgo} siden',
      files: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      confirm_transfer_delete:
        'Ikke så fort i svingene – er du sikker på at du vil slette denne overføringen?',
      confirm_forward:
        'Hvis du velger å videresende, erstattes den pågående overføringen. Vil du fortsette?',
      confirm_expired_transfer_delete:
        'Dette sletter filene og overføringsinformasjonen for godt. Fortsette?',
      deleting_now: 'Vi sletter denne for deg nå',
      deselect_all_transfers: {
        one: 'Fjern merkingen av alle overføringer',
        other: 'Fjern merkingen av alle %{count} overføringer',
      },
      downloads: 'Nedlastinger',
      expiration: 'Utløpsdato',
      expiration_next: 'Utløper om %{days}',
      expiration_no_date: 'Ingen utløpsdato',
      expiration_not_soon: 'Uløper ikke innen kort tid',
      include_archived_switch_label:
        'Inkluder informasjon for slettede overføringer',
      include_archived_switch_tooltip:
        'Disse teller ikke mot lagringsgrensen din',
      notify_completed:
        'Filoverføring fullført. Du kan lukke dette panelet. Eller så kan du fortsette å se på det, det går også helt greit.',
      preview: 'Forhåndsvisning',
      remove_permanently: 'Slett informasjonen for godt',
      search_placeholder: 'Søk etter filnavn eller e-postadresse',
      select_all_transfers: {
        one: 'Velg alle overføringer',
        other: 'Velg alle %{count} overføringer',
      },
      space_left: '%{space} av %{totalSpace} igjen',
      teams_tip: {
        subtitle:
          'Denne siden viser din egen overføringsaktivitet. I tilfelle du lurte, kan teammedlemmene dine også se sine egne overføringer.',
        title: 'Pro-teamet ditt vokser …',
      },
      title: 'Sendte overføringer',
      view_details: 'Vis detaljer',
      edit_display_name: 'Rediger tittel',
      received_time_ago: 'Mottatt for %{timeAgo} siden',
      search_title_placeholder: 'Søk etter tittel, filnavn eller e-postadresse',
      see_all: 'Vis alle (%{count})',
      sender: 'Avsender',
      sort_by_title: 'Tittel',
    },
    accountinfo: {
      pagename: 'Kontoinformasjon',
      signed_in_as: 'Pålogget som %{name}',
      sign_out: 'Logg ut',
      paid_on: 'Betalt',
      no_invoices:
        'Kvitteringene dine blir vist her, men du har visst ikke noen ennå. Heldige deg.',
      subscription_info:
        'Pro-abonnementet ditt på %{deal} fornyes automatisk %{autorenewal_attempt}.',
      payment_success: {
        monthly: 'Du er nå klar for en hel måned med WeTransfer Pro!',
        monthly_renewal: 'Du er nå klar for enda en måned med Pro!',
        yearly: 'Du er nå klar for et helt år med WeTransfer Pro!',
        yearly_renewal: 'Du er nå klar for enda et år med Pro!',
      },
    },
    changepassword: {
      pagename: 'Endre passord',
    },
    invoices: {
      pagename: 'Kvitteringer',
    },
    reviewbilling: {
      pagename: 'Bekreft betalingsinformasjonen din',
      information:
        'Hvis du vil endre betalingsmåte, må du samtidig fornye abonnementet',
      information_payment:
        'Du betaler %{deal} for neste %{period} med Pro. Abonnementet gjelder frem til %{expiry}',
    },
    renewbilling: {
      pagename: 'Gå gjennom informasjonen din og forny',
    },
    link_downloads_unsubscribe: {
      body: 'Du kan avslutte abonnementet på varsler om nedlasing fra overføringskoblinger. Du vil fremdeles kunne holde oversikt over nedlastingene dine i Sendt-panelet.',
      cta: 'Gå til mine Sendte overføringer',
    },
    onboarding: {
      step_two: {
        wallpaper: {
          choose_button: 'Velg fra galleri',
        },
        next_button: 'Alt er klart',
        description:
          'Velg bakgrunn og hvordan du vil at profilen din og nedlastingssidene skal se ut. Kult, ikke sant? Last opp din egen bakgrunn, eller bruk ett av forslagene våre.',
      },
      upload_wallpaper: {
        add_text: 'Last opp et bilde',
        add_description:
          'For å få best mulig resultat anbefaler vi at du laster opp et bilde på 2560 x 1600 piksler. Maks filstørrelse er 3 MB.',
        upload_text: 'Last opp et bilde eller en video',
      },
      preview: {
        wallpaper_credits_prefix: 'Bakgrunn av',
      },
      1: {
        description:
          '&quot;Tilpass hva folk skal se hver gang du sender dem filer. Og med din egen WeTransfer-side kan hvem som helst sende deg %{transfer_limit} overføringer – bare gi dem URL-adressen din. E-postadressen din vises på siden, så folk kan stole på at filene deres blir sendt til deg.<br /><br />\nFørst og fremst må du velge en URL-adresse.&quot;',
        next: 'Neste',
        skip: 'Hopp over',
        warning:
          '<strong>Pass på,</strong> du kan bare angi dette én gang (ikke for å stresse deg, altså …)',
        'blurb-1':
          'Opprett din egen WeTransfer-side, så du ser profesjonell ut hver gang noen laster ned filene dine, og gjør det (enda) enklere for hvem som helst å sende overføringer til deg.',
        'blurb-2': 'Først må du velge URL-adressen din.',
        welcome: 'Sett stemingen med din egen WeTransfer-side',
        information:
          'Ikke tenk så mye på det, du kan alltids endre det senere i <strong>varemerking</strong>.',
        description_unlimited:
          'Tilpass hva folk ser hver gang du sender dem filer. Din egen WeTransfer-side lar alle sende deg filer av alle størrelser—bare gi dem URL-adressen din. E-postadressen din vises på siden, slik at de kan stole på at filene blir sendt til deg.<br /><br />\nFørst velger du en URL.',
      },
      2: {
        description:
          'Du kan velge opptil fem forskjellige bakgrunner (ok, du kan kalle dem bakgrunnsbilder) for profilen din.\n\nGi deg selv eller merkevaren din oppmerksomheten, og lever filene dine med stil',
        pick: 'Velg fra galleriet vårt',
        title: 'Gjør et inntrykk med hver overføring',
        upload: 'Last opp din egen',
      },
      3: {
        description:
          '<strong>%{customLink}</strong> er konfigurert. Nå kan du legge til denne lenken på nettstedet ditt, så folk kan sende %{transfer_limit} overføringer til deg – eller så kan du … eh … gå og sende ting.',
        done: 'Ferdig',
        title: 'Oi, for en fin profil',
        description_unlimited:
          '<strong>%{customLink}</strong> er nå konfigurert. Du kan nå legge til denne koblingen på hjemmesiden din, og la folk sende deg overføringer av alle størrelser—eller så kan du … øh … gå og sende noe.',
      },
    },
    contact: {
      add_contact: 'Legg til kontakt',
      add_first_description:
        'Vi lagrer også e-postadressene du sender filer til her',
      add_to_transfer: 'Legg til i overføringen',
      remove_from_transfer: 'Fjern fra overføringen',
      confirm_delete: {
        one: 'Er du sikker på at du ønsker å slette denne kontakten?',
        other:
          'Er du sikker på at du ønsker å slette disse %{count} kontaktene?',
      },
      contact_count: {
        one: '%{count} kontakt',
        other: '%{count} kontakter',
      },
      edit: 'Rediger',
      mobile: {
        add: 'Legg til kontakt',
      },
      no_contacts: 'Legg til din første kontakt!',
      pagename: 'Kontakter',
      remove: 'Slett',
      search_count: {
        one: '%{count} søkeresultat',
        other: '%{count} søkeresultater',
      },
      search_placeholder: 'søk etter e-postadresse, navn eller bedrift',
      select: 'Velg',
      selected_text: {
        one: '%{count} kontakt valgt',
        other: '%{count} kontakter valgt',
      },
      teams_tip: {
        subtitle:
          'Når du sender noen en overføring, legger vi dem til i kontaktlisten din. Alle i teamet kan opprette sin egen liste.',
        title: 'Pro-teamet ditt vokser …',
      },
    },
    unsubscribeexpiration: {
      button: 'Avslutt abonnement',
      button_unsubscribed: 'Tilbake til WeTransfer',
      description:
        'Er du lei av å få e-post fra oss? Ikke noe problem! Vi kan slutte å minne deg på når overføringer er i ferd med å utløpe.',
      description_unsubscribed:
        'Du vil ikke lenger motta e-poster angående overføringer som utløper.',
      no_email: 'du',
      title: 'Velg å ikke lenger motta påminnelser på e-post',
      title_unsubscribed: 'Ferdig!',
      downloaded: {
        body: 'Skjønner. Du kan melde deg av påminnelser om at overføringene dine er i ferd med å utløpe når filene dine allerede har blitt lastet ned. Dette endrer ikke at vi sender deg e-post med påminnelser når ingen har lastet ned filene dine enda.',
        cta: 'Avslutt abonnement',
        title:
          '"Filene mine har blitt lastet ned. Jeg trenger ikke e-post om overføringer som utløper"',
      },
      not_downloaded: {
        body: 'Ikke noe problem. Du kan melde deg av påminnelser om at overføringene dine er i ferd med å utløpe, selv om de ikke har blitt lastet ned enda.',
        cta: 'Avslutt abonnement',
        title: 'Trenger du ikke e-post om overføringer som utløper?',
      },
      pro: {
        body_1:
          'Den er grei. Du kan melde deg av disse påminnelsene. Overføringsinformasjonen lar deg fremdeles holde oversikt over når overføringene dine utløper, og du kan når som helst endre utløpsdatoene.',
        body_2:
          'Psst, du kan kontakte oss på <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> om du ombestemmer deg eller sitter igjen med noe – ingen sure miner.',
        cta: 'Avslutt abonnement',
        title: 'Trenger du ikke e-post om overføringer som utløper?',
      },
    },
    about: {
      legal: {
        actionbar: {
          text: 'Er du sikker på at du vil fjerne informasjonskapslene dine?',
        },
      },
    },
    about_plus: {
      checklist: {
        title: 'Oppgrader til Pro i dag, for %{currency}%{price} i måneden',
      },
    },
    advertise: {
      gallery: {
        preview: 'Forhåndsvisning',
      },
      guidelines: {
        advert_static: {
          title: 'Statisk bakgrunn',
        },
      },
    },
    billinginfo: {
      pagename: 'Betalingsinformasjon',
    },
    help: {
      button_all_answers: 'Flere svar',
      page_title: 'Hurtighjelp',
      read_more: 'Les mer',
      search_button: 'Søk',
      search_placeholder: 'Hva kan vi hjelpe deg med?',
    },
    payment_redirect_loader: {
      title: 'Just a moment',
      subtitle: 'Please resist the temptation to refresh or close this page',
    },
    payment_pending: {
      order_in_progress: 'Laster …',
    },
    payment_update: {
      bancontact: {
        info: 'Varsko her – Bancontact belaster et engangsgebyr på 0,50 euro for å kontrollere at informasjonen din er riktig',
      },
      confirm_update: 'Bekreft',
      ideal: {
        info: 'Varsko her – iDEAL belaster et engangsgebyr på 0,01 euro for å kontrollere at informasjonen din er riktig',
      },
      info: 'Merk – iDEAL belaster et engangsgebyr på 0,01 euro for å kontrollere at informasjonen din er riktig',
      sofort: {
        info: 'Varsko her – SOFORT belaster et engangsgebyr på 1 euro for å kontrollere at informasjonen din er riktig',
      },
      title: 'Oppdater betalingsinformasjon',
      update_in_progress: 'Oppdaterer informasjonen din …',
    },
    sign_in: {
      account: 'Har du ikke en konto?',
      upgrade: 'Oppgrader til WeTransfer Pro',
    },
    signin: {
      account_cta: 'Opprett en konto',
      account_item_1: 'Send opptil %{size_limit}',
      account_item_2: 'Administrer overføringer',
      account_item_3: 'Lagre opptil %{storage_limit}',
      account_subtitle: 'Gratis',
      plus_cta: 'Få WeTransfer Pro',
      plus_item_1: 'Send opptil %{size_limit}',
      plus_item_2: 'Administrer overføringer',
      plus_item_3: 'Lagre opptil %{storage_limit}',
      plus_item_4: 'Dine egne bakgrunner',
      plus_item_5: 'En tilpasset URL-adresse',
      plus_item_6: 'Beskytt overføringer med passord',
      plus_month: '/måned',
    },
    teams: {
      invitee: {
        action_cancel_invite: 'Trekk tilbake invitasjon',
      },
      invitees: {
        title: 'Invitert – venter på svar',
      },
      member: {
        action_demote: 'Fjern som admin',
        action_promote: 'Gjør til admin',
        action_revoke: 'Fjern fra team',
      },
      members: {
        title: 'På teamet ditt',
      },
      no_access: {
        description: 'Hold deg oppdatert, så skal vi si fra når den er klar. ',
        title:
          'Oisann, det er ut til at denne funksjonen fremdeles er en hemmelighet. ',
      },
      subtitle: {
        members: {
          one: '%{count} medlem',
          other: '%{count} medlemmer',
        },
        pending: '%{pendingCount} invitert',
      },
      tip: {
        button: 'Les mer',
        subtitle:
          'Vår nye funksjon Pro for Team gjør WeTransfer-opplevelsen enda bedre! Legg til nye medlemmer gratis. Bruk det superenkle skjemaet nedenfor for å få i gang teamet ditt. Dere kan begynne med en gang de godtar invitasjonen din!',
        title: 'Ingen er på team alene …',
      },
      title: 'Team',
    },
    transfer_progress: {
      meta: {
        expires_in: 'Utløper om %{expiry}',
      },
      recipients: 'Sender til',
      upsell: {
        benefit_one: 'Se når filene dine ble lastet ned',
        benefit_three: 'Du kan gjennomgå og sende gamle overføringer på ny',
        benefit_two: 'Se hvem som lastet ned filene dine',
        button: {
          action: 'Mer informasjon',
          cancel: 'Nei takk',
        },
        heading:
          'Du kan enkelt administrere overføringene dine med WeTransfer Pro',
        title: 'Din overføringsinformasjon',
      },
    },
    transferReceived: {
      'empty-description':
        'Her finner du alle overføringene du har blitt tilsendt – det er ikke noe å bekymre seg for, de bruker ikke av lagringsplassen din.',
      'empty-title': 'Hold oversikt over overføringer',
      empty: {
        description:
          'Her finner du alle overføringene som er sendt til deg på e-post eller opplastet til deg – slapp av, de bruker ikke opp noe av lagringskapasiteten din.',
      },
      banner: {
        freeUser: {
          text: 'Oppgrader for å motta filer på en enkel måte. Få en egendefinert URL-adresse <strong>yourname.wetransfer.com</strong> og en side med ditt eget varemerke til opplastinger.',
          link: 'Les mer',
          cta: 'Oppgrader',
        },
        paidUser: {
          withUrl: {
            text: 'Hvem som helst kan sende deg overføringer på 200 GB på <strong>%{personalisedUrl}</strong>',
            cta: 'Kopier URL-adresse',
          },
          withoutUrl: {
            text: 'Angi din egen URL-adresse <strong>yourname.wetransfer.com</strong>, så kan hvem som helst laste opp filer til deg.',
            link: 'Les mer',
            cta: 'Gå til Varemerking',
          },
        },
      },
    },
    unsubscribeonboarding: {
      action: 'Avslutt abonnement',
      back: 'Tilbake til WeTransfer',
      contact:
        'Psst! Dersom du har problemer med noe, kan du ta kontakt på <a href="mailto:subscriptions@wetransfer.com">subscriptions@wetransfer.com</a> – vi tar det ikke ille opp.',
      done: 'Alt ferdig!',
      message:
        'Du kan avslutte abonnementet på introduksjonsmeldingene våre per e-post – men du behøver ikke å bekymre deg, fordi du fremdeles vil motta de viktige sakene.',
      title: 'Er det travelt i innboksen din?',
    },
    userinfo: {
      pagename: 'Personlig informasjon',
    },
    free_onboarding: {
      close: 'Lukk',
      finish_tour: 'Ferdig',
      next: 'Neste',
      send_files: 'Bare gå til sending av filer nå',
      start_tour: 'Se hva annet vi har',
      step_one: {
        body_1:
          'Nå som du har verifisert e-postadressen for kontoen din, trenger du ikke lenger å gjøre dette hver gang du overfører. Du slipper flere verifiseringskoder!',
        body_2:
          'Hold oversikten over alle overføringer du har sendt og mottatt på ett sted. Se hvor mange ganger filene dine har blitt lastet ned. Send på nytt, videresend eller slett overføringene dine – med ett klikk.',
        header_1: 'Verifisert en gang for alle',
        header_2: 'Administrer overføringene dine',
        subtitle:
          'Hils adjø til verifiseringskoder og tapte koblinger for nedlasting. Den nye kontoen din gir deg den enkleste måten å sende store filer på – gratis.',
        title_1: 'Send filer <strong>slik du selv vil</strong>',
        title_2: 'med WeTransfer',
      },
      step_three: {
        body_1:
          'Uansett om det er en filmsnutt på telefonen din eller en kobling fra datamaskinen, kan du lagre all inspirasjonen din på samme sted. For å komme i gang starter du Collect med startprogrammet (den greia øverst til venstre) eller koblingen nedenfor.',
        cta: 'Gå til Collect',
        title_1: '<strong>Lagre inspirasjon</strong> når du er på farten',
        title_2: 'med Collect',
      },
      step_two: {
        body_1:
          'Presenter idéer. Vis arbeid som pågår. Hold deg synkronisert. Uten å formattere flere lysbilder, noen gang. For å komme i gang åpner du Paste med startprogrammet (den greia øverst til venstre) eller koblingen nedenfor.',
        cta: 'Gå til Paste',
        title_1: 'Skap <strong>lysbilder på sekunder</strong>',
        title_2: 'med Paste®',
      },
    },
    modal: {
      portals_intro: {
        cta: 'Prøv portaler',
        pill: 'Flunkende ny funksjon',
        text: 'Vi introduserer <strong>portaler</strong>, en enkel måte å få avsendelsen du trenger på. Inviter klienter til å se filer og velge favoritter – uten å måtte laste ned noe som helst.',
        title: 'Del arbeid. Få tilbakemeldinger. Alt på samme sted.',
      },
    },
    not_found: {
      body: 'Gå tilbake til <a href="https://wetransfer.com/">wetransfer.com</a> eller gi øynene dine en oppmuntring med noen <a href="https://wepresent.wetransfer.com/">fine ting vi har skrevet</a>.',
      image_alt: 'Noe gikk galt',
      title: 'Uff da, den siden finner vi ikke.',
    },
    password_and_security: {
      title: 'Passord og sikkerhet',
      'two-factor-authentication': {
        description: {
          enabled: 'Siden %{date}',
        },
        disable: 'Deaktiver',
        done: 'Ferdig',
        enable: 'Aktiver',
        get_recovery_codes: 'Få gjenopprettingskoder',
        next_step: 'Neste',
        recovery_code_action: 'Generer nye koder',
        recovery_code_keep_safe:
          'Hver kode kan kun brukes én gang, men du kan alltid få flere dersom du trenger det.',
        recovery_code_need_more:
          'Trenger du flere gjenopprettingskoder? Du kan alltids generere noen nye, men du må huske at de gamle da blir ugyldige.',
        recovery_code_title: 'Gjenopprettingskodene dine',
        require_password_action: 'Skriv inn',
        require_password_text: 'Skriv inn passordet ditt for å fortsette',
        step_one_action: {
          app_store: 'Last ned fra App Store',
          google_play: 'Få den fra Google Play',
        },
        step_one_label: 'Trinn 1 (av 3)',
        step_one_text:
          'Du vil trenge en godkjenningsapp på telefonen din. Dersom du allerede har Google Authenticator (eller en annen app), klikker du på neste.',
        step_one_title: 'Last ned Google Authenticator',
        step_three_label: 'Trinn 3 (du er ferdig!)',
        step_three_text:
          'Dersom du trenger å logge på, og ikke har med deg telefonen din (vi har hørt at det skjer), kan du bruke disse gjenopprettingskodene. Vi kommer ikke til å lagre dem for deg eller vise dem igjen, så du bør få dem med deg nå – og holde dem like sikre som passkoden til bankkontoen din.',
        step_three_text_2:
          'Hold disse kodene like sikre som passordet til bankkontoen din. Hver kode kan kun brukes én gang.',
        step_three_title: 'Spar på gjenopprettingskoder',
        step_two_form: {
          error: 'Oisann, den koden er feil eller utløpt',
          label: 'Godkjenningskode',
        },
        step_two_label: 'Trinn 2 (halvveis)',
        step_two_text:
          'Bruk godkjenningsappen til å skanne denne strekkoden. Appen genererer en sekssifret godkjenningskode, og du angir denne nedenfor.',
        step_two_text_mobile:
          'Angi denne nøkkelen i godkjenningsappen din. Appen genererer en sekssifret godkjenningskode, og du skriver inn denne koden nedenfor.',
        step_two_title: 'Skann strekkode',
        step_two_title_mobile: 'Angi nøkkel',
        text: {
          protect_account:
            'Bruk telefonen din for å gi kontoen din et ekstra lag av sikkerhet.',
        },
        title: 'Godkjenning med to faktorer',
      },
    },
    'payment-cancellation': {
      bundle: {
        title: 'Få det beste fra Paste® og Collect',
      },
      cta: 'Nei, jeg vil fortsette med Pro',
      'cta-2': 'Avbryt abonnement',
      disclaimer: {
        collect: 'Lagringsplassen din i Collect går fra 200 GB til 5 GB',
        paste: 'Du går fra ubegrenset med deck i Paste® paste til bare 3',
        'team-member': 'Du blir fjernet fra %{currentTeam} på WeTransfer Pro.',
        teams:
          'Teamet ditt på %{amountOfMembers} blir fjernet fra %{currentTeam} i WeTransfer Pro',
        title:
          'Når abonnementet du bruker nå utløper på <strong>%{date}</strong>:',
        'transfer-expiry':
          'De aktive overføringene dine utløper etter 28 dager',
        'transfer-team-member':
          'Du vil ikke kunne sende eller motta overføringer som en del av teamet, og du vil ikke kunne administrere eksisterende teamoverføringer.',
      },
      'password-expiry': {
        title: 'Beskytt overføringer med passord og bestem selv når de utløper',
      },
      personalization: {
        title: 'Tilpass din egen WeTransfer-side',
      },
      portals: {
        text: 'Med %{planName} kan du bruke <a href="%{href}" target="_blank">portaler</a> til å dele arbeid som kunder kan gjennomgå – nedlastinger behøves ikke.',
        title: 'Del arbeid og motta tilbakemeldinger på samme sted',
      },
      'stay-pro': 'Behold abonnementet',
      'storage-limit': {
        title: 'Dra nytte av %{storage_limit_pro} med lagringsplass per person',
      },
      subtitle: 'Dersom du avbryter nå, vil du fra %{date} ikke lenger kunne:',
      teams: {
        'individual-text':
          '<a href="%{href}" target="_blank">Inviter teammedlemmer</a> til å sende, motta og administrere overføringer sammen – eller jobb alene gratis.',
        'team-member-text':
          'Du blir fjernet fra teamet ditt, og dere vil ikke lenger kunne sende, motta eller administrere overføringer sammen.',
        'team-owner-text':
          'Du har <a href="%{href}" target="_blank">%{amountOfMembers} teammedlemmer</a> som ikke lenger vil kunne sende, motta og administrere overføringer sammen.',
        title: 'Jobb med store ideer som et team',
      },
      title: 'Er du virkelig klar til å slutte med %{planName}?',
      'transfer-limit': {
        text: 'Akkurat nå kan du sende og motta større overføringer – mye mer enn den gratis %{transfer_limit_free}.',
        title: 'Sende overføringer som er 100 ganger større',
      },
      'transfer-unlimited': {
        text: 'Du kan sende (og motta) overføringer uten størrelsesgrenser for filene – uendelig mye mer enn de %{transfer_limit_free} du får gratis.',
        title: 'Send overføringer uansett størrelse',
      },
    },
    pricing: {
      pro: {
        per_person: 'per person',
      },
    },
    pricing_panel: {
      cta: {
        create_account: 'Opprett konto',
        current_plan: 'Gjeldende abonnement',
        sign_up: 'Registrer deg',
        switch_premium: 'Bytt til Premium',
        switch_pro: 'Bytt til Pro',
        upgrade: 'Oppgrader',
      },
      faq: {
        answers: {
          answer_1:
            'Du vil kunne sette i gang med WeTransfer Pro eller WeTransfer Premium så snart du har gjennomført betalingen. Vi sender deg også en bekreftelse på e-post med betalt faktura som vedlegg. <br /><br />\n \nSå snart du har kommet på innsiden, vil du umiddelbart kunne sende større overføringer, ta i bruk portaler og lage din egen WeTransfer-side. Dersom du har tidligere overføringer som ble sendt med gratisabonnementet, vil du også kunne endre utløpsdatoene til når du måtte ønske.',
          answer_2:
            'Når du bruker WeTransfer, kan hvem som helst laste ned filene dine – de trenger ikke å logge seg på eller registrere seg først. De må godta våre bruksvilkår, og vi ber dem om å godta informasjonskapsler, men det er alt! <br /><br />\n \nDersom du ønsker å dele arbeid eller samarbeide i portaler (WeTransfers nyeste funksjon), trenger verken kunder eller samarbeidspartnere å registrere seg for å se og velge filer, legge til kommentarer, gi godkjenning eller laste ned filer. Du trenger bare å legge til teammedlemmer i Pro- eller Premium-abonnementet dersom du vil at folk skal kunne legge til gjennomganger og lage portaler sammen med deg.',
          answer_3:
            'Med et Pro- eller Premium-abonnement kan du lage din egen WeTransfer-side der hvem som helst kan sende deg filer innenfor abonnementets størrelsesbegrensninger for overføringer. Det vil si at kunder og samarbeidspartnere kan gi deg de store filene du trenger, uten å måtte opprette en konto først – de trenger kun URL-en til siden din (vi kan likevel be dem om å bekrefte e-postadressene sine, for å beskytte deg mot «utenlandske prinser» som «ønsker å sende deg penger»).',
          answer_4:
            'Først må du registrere deg for et WeTransfer Pro- eller WeTransfer Premium-abonnement – du kan ikke legge til teammedlemmer med gratisabonnementet. Uansett hvilket abonnement du velger, vil teammedlemmene dine kunne utnytte de samme fordelene (slik at du ikke kan kjøpe Premium til deg selv og sette igjen noen teammedlemmer med Pro). Teammedlemmer vil kunne sende og motta større overføringer fra WeTransfer-siden din og administrere dem fra én delt oversikt.<br /><br />\n\nNår du har registrert deg for det abonnementet som passer best for teamet ditt, vil du kunne invitere så mange teammedlemmer du ønsker fra teaminnstillingene. Så lenge abonnementet ditt er aktivt, kan du legge til og fjerne medlemmer fra teamet når du måtte ønske.',
          answer_5:
            'Vi godtar PayPal i tillegg til kredittkort fra store selskaper som Visa, Mastercard og American Express. I enkelte land større vi også andre nettbaserte betalingssystemer. <br /><br />\n\nVi godtar ikke direkte bankoverføringer fordi du da må tegne et periodisk abonnement på månedlig eller årlig basis (vi sender deg en e-post før dette skjer første gang for å forberede deg).',
          answer_6:
            'Dersom du ikke har ubegrenset lagringsplass med WeTransfer Premium, må du enten frigjøre noe lagringsplass ved å slette noen av de sendte overføringene eller oppgradere abonnementet ditt. Du vil ikke kunne sende nye overføringer før dette er gjort. <br /><br />\n\nDersom du bruker WeTransfer gratis, slettes alle overføringer på inntil 2 GB automatisk etter syv dager. Så ta det med ro, det er ikke mulig for deg å overskride lagringsplassgrensen.',
          answer_6_variant_asterisk:
            'Du må frigjøre lagringsplass ved å slette noen av overføringene du har sendt, eller oppgradere abonnementet ditt. Før du gjør det, kan du ikke sende flere overføringer. <br /><br />\n\nHvis du har et Premium-abonnement og når 5 TB, kan du kontakte kundestøtten vår og be om mer lagringsplass opp til en maksimal årlig grense på 15 TB. <br /><br />\n\nHvis du bruker WeTransfer gratis, slettes alle de sendte overføringene dine på opptil 2 GB automatisk etter syv dager. Så det er ingen fare, det er ikke mulig for deg å overskride lagringsgrensen.',
          answer_6_variant_limited_storage:
            'Du må frigjøre litt lagringsplass ved å slette noen av overføringene du har sendt, eller oppgradere abonnementet ditt (med mindre du har et Premium-abonnement). Før du gjør det, kan du ikke sende flere overføringer. <br /><br />\n\nHvis du bruker WeTransfer gratis, slettes alle de sendte overføringene dine på opptil 2 GB automatisk etter syv dager. Så det er ingen fare, det er ikke mulig for deg å overskride lagringsgrensen.',
          answer_7:
            'Abonnementet ditt fornyes automatisk (vi sender deg en e-post før dette skjer for første gang), men du kan si det opp når du måtte ønske. <br /><br />\n\nFor å begynne å bruke WeTransfer gratis trenger du bare å gå til <strong>Konto</strong>-innstillinger og si opp abonnementet. Du (og eventuelle teammedlemmer du måtte ha) vil kunne fortsette å bruke Pro- eller Premium-abonnementet til slutten av gjeldende abonnementsperiode.',
          answer_8:
            'Millioner av mennesker over hele verden har satt sin lit til WeTransfer og vårt sett med verktøy for å overføre ideer. Hver måned deler 80 millioner mennesker 2 milliarder filer på vår fildelingsplattform. <br /><br />\n\nFor å beskytte ideene dine mot angrep og utnyttelse, krypteres filene når de overføres (TLS) og lagres (AES-256). Når filene dine er lagret, kan de kun nås ved å bruke de unike lenkene som sendes til avsender og mottaker.',
        },
        questions: {
          question_1: 'Hva skjer etter at jeg har registrert meg og betalt?',
          question_2: 'Må mottakerene mine også registrere seg?',
          question_3: 'Kan jeg motta større overføringer fra hvem som helst? ',
          question_4: 'Hvordan legger jeg til (og fjerner) teammedlemmer?',
          question_5: 'Hvilke betalingsmåter kan jeg bruke?',
          question_6: 'Hva skjer om jeg overskrider tildelt lagringsplass?',
          question_7: 'Hvordan sier jeg opp abonnementet?',
          question_8: 'Kan jeg stole på WeTransfer? Hvor trygt er det?',
        },
        title: 'Ofte stilte spørsmål',
      },
      feature_table: {
        branding: {
          features: {
            advertising: 'Annonsering (og kunst)',
            custom: 'Last opp din egen',
            feature_1: 'Egendefinert WeTransfer-side',
            feature_2: 'Bakgrunnsbilder',
            feature_3: 'Tilpassede WeTransfer-e-poster',
          },
          title: 'Vis frem ditt varemerke',
        },
        bundle: {
          collect: {
            storage: '%{collectStorageLimit} lagringsplass',
            title: 'Collect fra WeTransfer',
          },
          paste: {
            limited_decks:
              'Opptil %{pasteDecksLimit} presentasjoner med standard Paste-logo+',
            title: 'Paste® fra WeTransfer',
            unlimited_decks:
              'Ubegrenset antall presentasjoner med din egen logo',
          },
          title: 'Fullstendiggjør den kreative verktøykassen din',
        },
        expiry: 'Overføringer utløper etter %{days} dager',
        extra_storage: '%{storageLimit} ekstra per person',
        monthly_price: '%{price} i måneden per person',
        portals: {
          features: {
            feature_1: 'Portaler',
            feature_2: 'Gjennomganger',
            feature_3: 'Varemerke for kunde',
          },
          title: 'Del arbeid for tilbakemelding og godkjenning',
        },
        security: {
          features: {
            feature_1: 'Egendefinerte utløpsdatoer',
            feature_2: 'Passordbeskyttede overføringer',
            feature_3: 'Datakryptering',
            feature_4: 'Godkjenning med to faktorer',
          },
          title: 'Sikre overføringene dine',
        },
        storage_limit: '%{storageLimit} per person',
        teams: {
          features: {
            feature_1: 'Inviter teammedlemmer',
            feature_2: 'Delt overføringsoversikt',
            feature_3: 'Delt lagringsplass',
            feature_4: 'Delt varemerking',
          },
          title: 'Lever arbeid som et team',
          subtext: {
            text: 'Støttes bare hvis du kjøper et abonnement fra nettstedet vårt.',
            learn_more: 'Finn ut mer',
          },
        },
        tooltips: {
          tooltip_1:
            'Alle overføringer du sender teller mot lagringsplassen din',
          tooltip_10:
            'Du kan sende og lagre filer helt trygt med TLS- og AES-256-kryptering',
          tooltip_11:
            'Spor nedlastinger og administrer overføringer i fellesskap',
          tooltip_12:
            'Vis frem (team)arbeidet med bakgrunnsbilder og e-poster med eget varemerke',
          tooltip_13:
            'Paste er et verktøy som designer presentasjoner for deg med responsive farger, justering og layout',
          tooltip_14:
            'Collect lar deg lagre og organisere bilder, videoer, musikk og koblinger på tvers av ulike enheter',
          tooltip_2:
            'Folk kan laste ned filene dine uten innlogging eller registrering',
          tooltip_3:
            'Følg med på hvem som har (eller ikke har) lastet ned filene dine',
          tooltip_4: 'Organiser arbeidet ditt for hver kunde og hvert prosjekt',
          tooltip_5:
            'Inviter kunder til å se og velge filer, kommentere og godkjenne – uten å måtte laste ned noe som helst',
          tooltip_6:
            'Tilpass portalene dine for hver kunde, ved å legge til logo og tittel',
          tooltip_7:
            'Fra WeTransfer-siden din kan folk laste ned filer og sende deg overføringer innenfor størrelsesbegrensningen i abonnementet ditt',
          tooltip_8:
            'Bakgrunnsbilder- og videoer kan ses i bakgrunnen når du sender og mottar filer på wetransfer.com',
          tooltip_9:
            'Kult! Vi trodde faktisk ingen ville lese disse – du viste at vi tok feil. Gratulerer! Skjermbilder kan bli retvitret av @WeTransfer',
        },
        transfer_classic: {
          features: {
            feature_1: 'Størrelsesbegrensning på overføring',
            feature_2: 'Lagring',
            feature_3: 'Nedlastinger uten konto',
            feature_4: 'Spor nedlastinger',
            feature_5: 'iOS-app',
          },
          title: 'Send store filer',
        },
        unlimited: 'Ubegrenset',
        yearly_price: '%{price} i året per person',
      },
      header: {
        subtitle:
          'Uansett om du sender store filer for moro skyld eller leverer arbeid til kunder – hold de kreative prosjektene gående med WeTransfer.',
        title: {
          english_1: 'Du har ideene,',
          english_2: 'vi har abonnementene',
          general: 'Abonnementer og priser',
        },
      },
      plans: {
        billing: {
          discount: 'Spar %{percentage} (ja takk)',
          monthly: 'Månedlig fakturering',
          yearly: 'Årlig fakturering',
        },
        free: {
          subtitle: 'Send filer en gang i blant',
          title: 'Gratis',
          usp: {
            feature_1: 'Send opptil %{transferLimit}',
            feature_2: 'Behøver ikke å bekrefte overføringer',
          },
        },
        premium: {
          subtitle: 'Del arbeid uten begrensninger',
          title: 'Premium',
          usp: {
            feature_1: 'Ingen størrelsesgrense for overføringer',
            feature_2: 'Ubegrenset lagringsplass',
            feature_2_subtitle:
              '*Startgrensen er på %{storageLimit}, med mulighet til å legge til ekstra lagringsplass på forespørsel. Vi har en maksimal årlig grense på %{annualStorageLimit}. Se <a href="/legal/terms" data-route-type="premium" target="_blank">bruksvilkårene</a> våre hvis du vil ha mer informasjon.',
            feature_3: 'Ubegrensede portaler og gjennomganger',
          },
        },
        pro: {
          subtitle: 'Send skikkelig store filer jevnlig',
          title: 'Pro',
          usp: {
            feature_1: 'Send og motta opptil %{transferLimit}',
            feature_2: '%{storageLimit} lagringsplass per person',
            feature_3: '%{portalsLimit} portal, ubegrensede gjennomganger',
          },
        },
        tagline: {
          free: 'ingen penger, ikke noe problem',
          monthly: 'i måneden per person',
          yearly: 'i året per person',
          per_person_monthly: 'per person, fakturert månedlig',
          per_person_yearly: 'per person, fakturert årlig',
          tax_included: 'inkludert mva.',
        },
        title: 'Velg abonnement',
        month: 'måned',
      },
      skip_link: 'Gå til flere funksjoner',
    },
    pro_classic: {
      hero: {
        cta_1: 'Les mer',
      },
    },
    splashpage: {
      bundle: {
        title_new: 'Du har ideene, vi har abonnementene',
      },
      cta: 'Jeg vil bare sende filer',
      free_panel: {
        cta: 'Opprett konto',
      },
      plan: {
        free: {
          feature_1: 'Send opptil <strong>%{transfer_limit}</strong>',
          feature_2: 'Behøver ikke å bekrefte overføringer',
          subtitle_new: 'For dem som sender filer av og til',
          title: 'Gratis',
        },
        pro: {
          feature_1: 'Send og motta opptil <strong>%{transfer_limit}</strong>',
          feature_2: 'Bestem når overføringer utløper',
          feature_5: '1 TB lagringsplass per person',
          subtitle_new: 'For fagfolk og team',
          title: 'Pro',
        },
      },
      reciever: {
        free: {
          cta: 'Registrer deg nå',
          descripttion: 'Hold oversikt over overføringer',
          feature_1: 'Send opptil 2 GB',
          feature_2: 'Motta overføringer i én oversikt',
          title: 'Gratis',
        },
        pro: {
          cta: 'Finn ut mer',
          descripttion: 'Få det beste WeTransfer har å tilby',
          feature_1: 'Send og motta opptil %{transfer_size}',
          feature_2:
            '%{storage_size} med lagringskapasitet for overføringer per person',
          feature_3: 'Send overføringer med tilpassede innstillinger',
          title: 'Pro',
        },
        title: 'Ikke la overføringer bli borte i innboksen din.',
      },
      title: 'Få mest mulig ut av nye WeTransfer',
    },
    teamsettings: {
      invite: {
        cta: 'Invitere team',
        pagename: 'Inviter team',
      },
      manage: {
        cta: 'Administrere team',
      },
      members:
        'Du har %{amountOfMembers} teammedlemmer. <a href="%{href}">%{cta}</a>',
      no_members: 'Enn så lenge, er du alene! <a href="%{href}">%{cta}</a>',
      settings: {
        pagename: 'Innstillinger for team',
      },
    },
    universal_onboarding: {
      team_feature: {
        subtitle: 'Slå deg sammen med andre og overfør sammen',
        context:
          'Send og motta overføringer som et team med felles lagringskapasitet, varemerking og tilgang til hverandres overføringer.',
        invite_team: 'Inviter team',
        dismiss: 'Kanskje senere',
      },
      feature_highlight: {
        free_context:
          'Nå kan du administrere sendte og mottatte overføringer i én enkel oversikt. Få nedlastingstidspunktet ned til minuttet. Send på nytt, videresend eller last ned overføringene med ett klikk. Så enkelt',
        free_subtitle: 'Alle overføringene dine på ett sted',
        paste_collect_link:
          'Gå til <a href="%{pasteUrl}" rel="external">%{pasteName}</a> eller <a href="%{collectUrl}" rel="external">%{collectName}</a>',
        premium_context:
          'Du kan nå sende overføringer i alle størrelser samt opprette din egen <b>WeTransfer-side</b> for å tilpasse det folk ser når de laster ned filene dine. Er du klar til å velge URL og bakgrunnsbilder?',
        premium_cta: 'Opprett side',
        premium_dismiss: 'Kanskje senere',
        premium_subtitle: 'Konfigurer WeTransfer-siden din',
        premium_team_context:
          'Du kan nå sende og motta overføringer i alle størrelser fra teamets <b>egendefinerte WeTransfer-side</b>.',
        pro_context:
          'Du kan nå sende inntil %{transfer_limit} på en gang samt opprette din egen <b>WeTransfer-side</b> for å tilpasse det folk ser når de laster ned filene dine. Er du klar til å velge URL og bakgrunnsbilder?',
        pro_team_context:
          'Du kan nå sende og motta overføringer på %{transfer_limit} fra teamets <b>egendefinerte WeTransfer-side</b>.',
        send_cta: 'Begynn å sende filer',
        team_subtitle: 'Lever kreativt arbeid som et team',
      },
      marketing: {
        context:
          'Nå som vi vet litt om deg, vil vi gjerne fortelle deg litt om oss. Kunne du tenke deg historier om kreativitet og de siste WeTransfer-nyhetene?',
        image_alt_text:
          'Eksempel på e-postinnhold, deriblant nye produktfunksjoner, bransjerapporter og WePresent-artikler som forteller historier om kreativitet.',
        opt_in: 'Ja takk',
        opt_out: 'Nei takk',
        unsubscribe:
          'Du kan når som helst avslutte abonnementet – ingen sure miner.',
      },
      welcome: {
        context:
          'Når vi blir bedre kjent med deg, hjelper det oss til å forbedre tjenesten.',
        cta: 'Fortsett',
        dismiss: 'Hopp over',
        dropdown_options: {
          architecture: 'Arkitektur / Konstruksjon',
          data: 'Data / Finans / Juridisk',
          design: 'Design / Illustrasjon',
          education: 'Utdanning / Opplæring',
          marketing: 'Markedsføring / PR',
          music: 'Musikk / Lyd',
          other: 'Annet (og stolt av det)',
          photography: 'Fotografering',
          product: 'Produkt / Programvare',
          sales: 'Salg / Kunderelasjoner',
          video: 'Video / Animasjon',
        },
        free_tier_title: 'Velkommen til WeTransfer, %{name}!',
        placeholder: 'Hmm, skal vi se …',
        question: 'Først av alt, hvilket fagområde jobber du innen?',
        team_title: 'Du er med i teamet, %{name}!',
        tier_title: 'Velkommen til WeTransfer %{tier}, %{name}!',
        data_opt_in: {
          checkbox_label:
            'La WeTransfer bruke data du deler til å vise deg skreddersydde annonser på og utenfor nettstedene våre.',
          tooltip_anchor: 'Hva betyr det?',
          tooltip: {
            title: 'Hvordan bruker WeTransfer mine data?',
            p1: 'Vi bruker e-postadressen din til å vise deg (og andre som deg) WeTransfer-annonser på nettsteder du besøker, som sosiale medier.',
            p2: 'Vi bruker også arbeidsfeltet ditt for å gi deg en bedre opplevelse på nettstedene våre.',
            p3: 'Dataene du velger å dele med oss, er alltid sikre.',
            button: 'Skjønner',
          },
        },
      },
    },
    workspace_bar: {
      tooltip_text: 'Legg til andre i arbeidsområdet ditt',
      workspace: 'Arbeidsområde',
      manage_workspace: 'Administrer arbeidsområdet',
    },
  },
  exception: {
    activate_subscription_exception:
      'Noe gikk visst galt. Prøv igjen eller ta kontakt med <a href="https://wetransfer.zendesk.com" rel="external">brukerstøtte</a>',
    complete_payment_exception:
      'Noe gikk visst galt. Prøv igjen eller ta kontakt med oss via <a href="https://wetransfer.zendesk.com" rel="external">hjelpesenteret</a>',
    retrieve_checkout_exception:
      'Noe gikk visst galt. Prøv igjen eller ta kontakt med <a href="https://wetransfer.zendesk.com" rel="external">brukerstøtte</a>',
    source_id_error:
      'Beklager, men vi kunne ikke behandle denne forespørselen – prøv igjen',
    three_d_secure: 'For øyeblikket støtter vi ikke 3D Secure-kort.',
    something_went_wrong:
      'Noe gikk visst galt. Prøv igjen eller ta kontakt med <a href="https://wetransfer.zendesk.com" rel="external">brukerstøtte</a>',
    signin_no_data_exception:
      'Noe gikk visst galt. Sjekk brukernavnet og passordet, og prøv igjen',
    signin_exception: 'Beklager, men vi klarte ikke å logge deg på. Prøv igjen',
    signout_exception:
      'Vi kunne visst ikke logge deg ut. Rart … Prøv å laste inn siden på nytt for å se om du fortsatt er pålogget.',
    signup_account_error:
      'Noe gikk visst galt i løpet av registreringen. Kontroller opplysningene du har lagt inn og prøv igjen',
    retrieve_account_exception:
      'Noe gikk visst galt. Vi vil nødig spørre, men kan du gjøre et nytt forsøk?',
    update_account_error:
      'Beklager, men vi kunne ikke oppdatere kontoinformasjonen din. Kan du prøve igjen?',
    retrieve_subscription_exception:
      'Vi fant ikke betalingsinformasjonen din. Prøv igjen',
    update_subscription_exception:
      'Vi kunne ikke oppdatere betalingsinformasjonen din. Prøv igjen eller ta kontakt med <a href="https://wetransfer.zendesk.com" rel="external">brukerstøtte</a>',
    autorenewal_not_supported: 'Denne kontoen støtter ikke automatisk fornying',
    email_background_upload_validation_error:
      'Filen er for stor, eller er i et annet format enn PNG eller JPG. Prøv med et annet bilde',
    email_background_upload_validation_error_videos:
      'Filen er for stor, eller er i et annet format enn PNG eller JPG. Prøv med et annet bilde',
    update_password_exception:
      'Beklager, men vi kunne ikke oppdatere passordet ditt. Prøv igjen',
    retrieve_device_exception:
      'Vi fant ingen tilkoblede enheter. Ikke en eneste én! Prøv igjen.',
    remove_device_exception: 'Vi kunne ikke fjerne enheten',
    renew_subscription_exception:
      'Vi kunne ikke fornye kontoen din akkurat nå. Prøv igjen senere',
    invoices_retrieve_exception: 'Vi fant ikke kvitteringene dine. Prøv igjen',
    invoice_download_exception:
      'Vi klarte ikke å laste ned kvitteringen. Prøv igjen',
    image_not_valid: 'Oi, virker som om dette bildet ikke kan lastes opp',
    update_profile_error: 'Vi kunne ikke oppdatere profilen din. Prøv igjen',
    retrieve_profile_exception:
      'Vi kunne ikke finne profilinnstillingene dine. Prøv igjen',
    s3_exception: 'Oi, noe gikk galt i løpet av opplastingen. Prøv igjen',
    file_size_limit_reached:
      'Det behøver ikke være stort for å være flott. Last opp et bilde på maks 3 MB',
    retrieve_transferlist_exception:
      'Vi fant ikke listen din over overføringer',
    retrieve_transfer_exception: 'Vi fant ikke overføringsinformasjonen',
    delete_transfer_exception: 'Vi kunne ikke slette overføringen',
    delete_transfers_exception: 'Vi kunne ikke slette overføringene',
    update_expiry_exception: 'Vi kunne ikke oppdatere utløpsdatoen',
    add_contact_exception: 'Kontakten ble ikke lagt til',
    complete_last_order_exception: 'Vi kunne ikke fullføre bestillingen din',
    edit_contact_exception: 'Kontakten ble ikke oppdatert',
    remove_contact_exception: 'Kontakten ble ikke slettet',
    request_password_reset_exception:
      'Beklager, men vi klarte ikke å behandle forespørselen om tilbakestilling. Prøv igjen',
    request_password_reset_no_user: 'Dobbeltsjekk e-postadressen og prøv igjen',
    reset_password_error:
      'Noe skar seg da passordet ditt skulle tilbakestilles. Prøv igjen',
    reset_password_exception:
      'Beklager, men vi klarer ikke å tilbakestille passordet ditt akkurat nå. Prøv igjen',
    reset_password_token_invalid:
      'Koblingen for tilbakestilling fungerer visst ikke. Følg instruksjonene vi sendte deg på e-post, eller begynn på nytt',
    retrieve_last_order_exception: 'Vi finner ikke bestillingen din',
    retrieve_ternot_exception:
      'Vi har dessverre problemer med å finne overføringen din. Prøv igjen',
    signin_invalid_credentials:
      'E-postadressen og passordet stemmer ikke overens. Dobbeltsjekk og gjør et nytt forsøk',
    unsubscribe_expiration_exception:
      'Noe gikk galt da vi skulle avslutte abonnementet ditt. Prøv igjen',
    unsubscribe_expiration_invalid_signature:
      'Koblingen for å avslutte abonnementet virket ikke. Prøv igjen',
    cancel_subscription_exception:
      'Det virker som om noe gikk galt. Vi kunne ikke avbryte abonnementet ditt. Prøv igjen senere.',
    payment_cancelled:
      'Noe gikk visst galt. Prøv igjen eller ta kontakt med oss via <a href="https://wetransfer.zendesk.com" rel="external">hjelpesenteret</a>',
    profile_picture_upload_validation_error:
      'Filen er for stor, eller er i et annet format enn PNG eller JPG. Prøv med et annet bilde',
    reactivate_subscription_exception: 'Noe gikk galt – prøv igjen',
    retrieve_contactlist_exception: 'Vi kunne ikke finne kontaktlisten din',
    source_retrieve_error:
      'Noe gikk visst galt. Prøv igjen eller ta kontakt med oss via <a href="https://wetransfer.zendesk.com" rel="external">hjelpesenteret</a>',
    token_error: 'Noe gikk galt. Vil du prøve igjen?',
    update_user_error:
      'Det oppstod et problem ved oppdateringen av informasjonen din',
    wallpaper_upload_validation_error:
      'Filen er for stor, eller er i et annet format enn PNG eller JPG. Prøv med et annet bilde',
    wallpaper_upload_validation_error_videos:
      'Oisann, ser ut som om videoen din ikke passer med kravene – prøv på nytt',
    declined_contact_bank_error:
      'Beklager, vi kunne ikke behandle denne betalingen – ta kontakt med banken din',
    invalid_password: 'Passordet ble ikke gjenkjent',
    otp_token_invalid: 'Oisann, den koden er feil eller utløpt',
    projects_load_exception: 'Vi kan ikke laste prosjektene dine akkurat nå',
    update_information_throttle:
      'Det oppstod et problem ved oppdateringen av informasjonen din. Ta en %{throttle_time}-pause før du prøver igjen.',
    price_amount:
      'The transfer price must be greater than %{currencySymbol}1.00 and less than %{currencySymbol}999',
  },
  navigation: {
    about_us: {
      items: {
        products: 'Produkter',
        plans_and_pricing: 'Abonnementer og priser',
        pricing: 'Priser',
        pro_and_premium: 'WeTransfer Pro og Premium',
        about: 'WeTransfer',
        plus: 'Pro',
        apps: 'Apps',
        advertise: 'Annonser',
        upgrade: 'Oppgrader',
      },
      name_1_2019: 'Bedrift',
      name: 'Bedrift',
    },
    home: {
      name: 'Hjem',
    },
    help: {
      name: 'Hjelp',
    },
    got_plus: {
      name: 'Got Pro?',
    },
    signed_in: {
      name: 'Pro',
    },
    user: {
      items: {
        transfers: 'Overføringer',
        contacts: 'Kontakter',
        profile: 'Profile',
        account: 'Konto',
        received: 'Mottatte',
        sent: 'Sendte',
        teams: 'Team',
        projects: 'Projects',
      },
    },
    feedback: {
      name: 'Feedback',
    },
    sign_out: 'Logg ut',
    signin: {
      name: 'Logg inn',
    },
    branding: 'Varemerking',
    label: {
      beta: 'Beta',
      new: 'Nytt',
    },
    login: 'Logg på',
    logout: 'Logg av',
    portals: 'Portaler',
    signup: 'Registrer deg',
    features: {
      name: 'Funksjoner',
      all: 'Alle funksjoner',
      file_sharing: 'For fildeling',
      collaboration: 'For samarbeid',
      security: 'For datasikkerhet',
      branding: 'For merkevarebygging',
      fast_feedback: 'For raske tilbakemeldinger',
    },
    referral: 'Verv venner',
    switcher: {
      create_free_account: 'Legg til gratis',
      just_you: 'Kun deg',
      team: 'Team',
      team_member_count: '%{amountOfMembers} medlemmer',
    },
  },
  transfer: {
    bubble: {
      errors: {
        no_internet: 'Hmm, du er ikke koblet til internett',
        begins_space:
          'Vi kan ikke sende filer som har navn som starter med mellomrom. Endre navn og prøv igjen.',
        begins_stop:
          'Vi kan ikke sende filer som har navn som starter med punktum. Endre navn og prøv igjen.',
        blocked:
          'Vi kunne ikke laste inn WeTransfer. Du ser ut til å være blokkert',
        generic: 'Vi er lei for det, men noe gikk galt i løpet av overføringen',
        has_blackslash:
          'Vi kan ikke sende filer som har omvendt skråstrek (backslash) i navnet. Endre navn og prøv igjen.',
        has_linebreak:
          'Vi kan ikke sende filer som har linjeskift i navnet. Endre navn og prøv igjen.',
        incorrect_recipient: 'En av e-postadressene du har lagt inn er feil',
        incorrect_sender:
          'Det ser ut til å være problemer med e-postadressen din',
        io_error: 'Det er problemer med filene dine',
        long_filename:
          'Vi kan ikke sende filer som har mer enn 250 tegn i navnet. Endre navn og prøv igjen.',
        long_message: 'Meldingen er litt for lang. Kort den ned',
        missing_default_recipient:
          'Kun e-postadresser registrert for WeTransfer Pro kan motta mer enn %{free_transfer_limit}. Last inn siden på nytt for å prøve igjen.',
        no_clipboard: 'Du ser ikke ut til å ha kopiert koblingen',
        no_files: 'Du ser ikke ut til å ha lagt til filer ennå!',
        no_folders: 'Du må pakke/komprimere mappen før vi kan sende den',
        no_recipient: 'Vi må vite e-postadressen som filene skal sendes til',
        no_sender: 'Vi trenger nå bare e-postadressen din, så er vi klar',
        too_big:
          'Ikke så fort i svingene – vi kan bare overføre %{upload_limit} om gangen',
        too_many_recipient:
          'Oisann! %{count} personer er grensen vår. Trenger du flere? Hva med å benytte en kobling for overføringen.',
        unavailable:
          'Beklager, men overføringen har blitt slettet, og er ikke lenger tilgjengelig',
        wrong_password:
          'Oi, passordet er visst ikke riktig. Prøv igjen, eller dobbeltsjekk med vedkommende som sendte deg overføringen.',
        default_title: 'Oisann!',
        duplicate_filename:
          'Vi kan ikke sende flere filer med samme navn. Endre navnet, og prøv igjen.',
        firstaccept: 'Du må godkjenne først, før du kan sende',
        not_downloadable:
          'Noe gikk galt da vi skulle hente filene dine. Last inn siden på nytt, og prøv igjen.',
        recaptcha: {
          text: 'Noe gikk galt, prøv igjen!',
          title: 'Åh nei …',
        },
        too_big_text:
          'Du kan ikke overføre mer enn %{upload_limit} om gangen. Send opptil %{plus_limit} med Pro. ',
        too_big_title: 'Hei storsender',
        too_many_files: 'Du kan ikke sende flere enn %{count} filer samtidig',
        too_many_recipient_text:
          'Til kan overføre filer til opptil 50 personer med Pro.',
        too_many_recipient_title: 'Det er for mange personer',
        unavailable_forward:
          'Denne overføringen har dessverre blitt slettet, og kan derfor ikke videresendes',
        verify: {
          button: 'Ny kode, er du snill!',
          text: 'Prøv igjen eller be om en ny kode. ',
          title: 'Oisann!',
        },
      },
      buttons: {
        check_out: 'Test det ut!',
        help: 'Brukerstøtte',
        plus: 'Skaff deg Pro',
        get_link: 'Få en kobling',
      },
      tips: {
        change_type:
          'Send filene på e-post, eller generer en egen overføringskobling som du kan dele nøyaktig som du vil',
        contacts:
          'Alle som sender filer til deg, blir automatisk lagt til som kontakter',
        expiry:
          'WeTransfer Pro lar deg selv velge når overføringene utløper. (Du kan til og med endre utløpsdatoen etter at overføringen har blitt sendt!)',
        free_limit:
          'Den gode nyheter er at du kan sende opptil %{size} om gangen. Den enda bedre nyheten er at du kan bruke tjenesten så ofte du vil!',
        message:
          'Her kan du, hvis du ønsker, legge til en melding som sendes sammen med overføringen din',
        password:
          'For å øke sikkerheten kan du beskytte overføringen din med et passord. Men husk: vi legger ikke til passordet i e-posten, så du må passe på å gi det til riktig vedkommende!',
        recipient_limit:
          'Legg til opptil %{email_limit} e-postadresser, eller åpne menyen ved siden av overføringsknappen for å opprette en kobling.',
        transfer_history: 'Overføringen din er lagret i overføringsoversikten',
        your_email:
          'Legg inn din egen e-postadresse her, så gir vi deg beskjed når filene har blitt lastet ned',
        link_transfer:
          'Visste du at du kan hente overføringskoblingen din her?',
        previews_receiver:
          'Bilder sendt av Pro-brukere kan nå forhåndsvises før de lastes ned. Bare klikk på filen for å se hva den inneholder!',
        previews_sender:
          'Bildene du sender kan nå forhåndsvises før de lastes ned',
        vrl_text: 'Du kan nå vise filene dine uten å måtte laste dem ned.',
        vrl_title: 'Vis filene dine',
        zip_text: 'Sender du en mappe? Vi pakker den for deg',
        zip_title: 'Du trenger ikke pakke',
        add_display_name_tooltip:
          'Gi overføringen din en tittel, slik at folk vet hva filene dine handler om. Dette gjør det også lettere å finne dem senere.',
        anonymous_sender: {
          button: 'Få en kobling',
          text: 'Legg inn e-postadressen, slik at vi kan si fra når filene dine blir lastet ned.\n\nDu må bekrefte e-postadressen din, så vi vet at det virkelig er deg. Har du ikke lyst til å bekrefte hver gang?',
          text_locked_recipient:
            'Legg inn e-postadressen din, slik at vi kan si fra når filene dine blir lastet ned.\n\nDu må bekrefte e-postadressen din, så vet at det virkelig er deg.',
        },
        prefer_link: {
          button: 'Få en kobling',
          text: 'Ikke lyst til å bekrefte e-postadressen din? Helt greit.',
        },
      },
      button: {
        previews_receiver_learnmore: 'Les mer',
        previews_sender_learnmore: 'Les mer',
      },
      recipient_locked_text:
        'Denne siden er for at eieren skal kunne motta filer. Logg på om dette er deg, eller gå til <a href="https://wetransfer.com">wetransfer.com</a> for å sende til andre.',
      recipient_locked_title: 'Varsko her',
      title: {
        previews_receiver: 'Nå med forhåndsvisning av bilder',
        previews_sender: 'Nå med forhåndsvisning av bilder',
      },
    },
    download: {
      blocked: {
        link: 'Finn ut mer',
        text: 'Denne overføringen har blitt rapportert og kan ikke lastes ned.',
        title: 'Overføring blokkert',
      },
      title: 'Vi er klare. Er du?',
      expires: 'Filene utløper om %{relative_time}',
      expires_never: 'Ingen utløpsdato',
      files: '%{count} filer, %{size}',
      format: '%{files}・%{expires}',
      expand: 'mer',
      download_link: 'Nedlastingskobling',
      files_nosize: {
        one: '%{count} fil',
        other: '%{count} filer',
      },
      show_all_files_mobile: 'Vis alle filer',
      zip_information:
        'Hvis du velger å laste ned alle filene samtidig, blir de samlet i en ZIP-fil – <a href="https://wetransfer.zendesk.com/hc/en-us/sections/201887176-Downloading-a-transfer-on-a-mobile-device" rel="external">les mer</a>',
      files_label: 'Files',
      message: 'Melding',
      learn_more: 'finn ut mer',
      expires_in: 'Utløper om %{expiry}',
      download_all_zip: 'Last ned alle vil laste ned alle filene som en .zip',
      back_to_transfer: 'Tilbake til overføring',
      cookie_text:
        'Vi bruker informasjonskapsler for å gi deg den beste opplevelsen. Ikke vær redd, vi selger ikke opplysningene dine til tredjeparter. Administrer <a href="https://wetransfer.com/legal/manage-cookies" rel="external">datainnstillingene dine</a>.',
    },
    preview: {
      open_grid: 'Forhåndsvis',
      click_to_open: 'Klikk for forhåndsvisning',
      grid: 'Elementer i denne overføringen',
      link: 'Nettsted',
      not_previewable: 'Forhåndsvisning utilgjengelig',
      now_open: 'Forhåndsvisning åpen',
      open_link: 'Åpne kobling i ny fane',
      open_link_short: 'Åpne kobling',
      overview: 'oversikt',
      reload: 'Klikk her for å laste på nytt',
      something_went_wrong: 'Auda, noe gikk galt',
      tap_to_open: 'Trykk for å vise',
      toobig_copy:
        'Vi kan bare forhåndsvise bilder opptil 50 MB – <a href="https://wetransfer.zendesk.com/" rel="external">les mer her</a>',
      toobig_title: 'Uffda – dette bildet er for stort til å forhåndsvises',
      unsupported_copy:
        'Se <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115003447483" rel="external">denne artikkelen</a> for å finne ut hvilke filer vi kan forhåndsvise',
      unsupported_title: 'Vi kan ikke forhåndsvise denne filen (enda)',
      visit_website: 'Besøk nettstedet',
    },
    complete_mobile: {
      email_text:
        'Det er sendt en e-post om overføring. Overføringen din er tilgjengelig i %{expires}',
      link_text: 'Kopier nedlastingskoblingen din:',
      email_text_no_expiry: 'Det ble sendt en e-post til mottaker.',
    },
    'consent-manager': {
      art: {
        'short-v': {
          subtitle:
            '<b>Visste du at 30 % av annonseplassen vår går til kunstnere?</b> Ved å godta informasjonskapslene våre, lar du oss vise deg litt kunst, saker vi bryr oss om og noen prisvinnende annonser som ikke kommer i veien. ',
          text: 'Vil du også tillate informasjonskapsler fra tredjeparts annonsepartnere, slik at vi kan tilpasse annonsene du ser? ',
          title: 'Informasjonskapslene våre gir næring til kulturen',
        },
        subtitle:
          '<b>Derfor går 30 % av annonseplassen vår til kunstnere.</b> Ved å godta informasjonskapslene våre, lar du oss vise deg litt kunst, saker vi bryr oss om og noen prisvinnende annonser som ikke kommer i veien. ',
        text: 'Nettstedet vårt bruker informasjonskapsler for å hjelpe det til å fungere riktig, la oss forstå hvordan du bruker WeTransfer og hjelpe oss bedre ytelsen. Vil du også tillate informasjonskapsler fra tredjeparts annonsepartnere, slik at vi kan tilpasse annonsene du ser?',
        title: 'Vi mener at kunst kan flytte fjell',
        'title-small': 'Velkommen til WeTransfer',
      },
      'button-accept': 'Jeg godtar',
      'button-accept-all': 'Godta alle',
      'button-ccpa': 'Velg bort salg av personopplysninger',
      'button-cookies-privacy': 'Dine personvernvalg',
      'button-reject': 'Nei takk',
      'button-save': 'Lagre',
      'button-save-and-exit': 'Lagre og lukk',
      'ccpa-banner-text':
        'Vi bruker informasjonskapsler for å sikre at du får best mulig opplevelse på nettstedet vårt. Ikke vær redd, vi selger ikke opplysningene dine til tredjeparter. Vil du velge bort likevel? <a href="%{href}">Administrer innstillinger</a>',
      'ccpa-body':
        'Fordi du er i USA, beskyttes rettighetene dine av Californias Consumer Privacy Act (CCPA), og du kan be oss om å slutte å selge personopplysningene dine. Det betyr ikke at vi ellers vil auksjonere bort personopplysningene eller dine private filer til høystbydende – det har vi aldri gjort og kommer aldri til å gjøre! Vi strekker oss langt for å holde det digitale fotavtrykket ditt lite, sikkert og under din kontroll. Du kan lese mer om hvilke data vi samler inn og hvorfor i <a href="%{href}">dine personvernvalg</a>',
      'ccpa-donotsell': 'Ikke selg personopplysningene mine',
      'ccpa-header': 'Velg bort salg av personopplysninger',
      'ccpa-intro':
        'Som et ansvarlig teknologifirma som er forpliktet til et bedre internett, selger vi ikke opplysningene dine til tredjeparter. Men du har rett til å offisielt velge bort slikt salg likevel.',
      'ccpa-variant-test-text':
        'Vi bruker informasjonskapsler for å gi deg en smidig opplevelse på nettstedet og for å tilpasse annonsene du ser. <a href="%{href}">Administrer informasjonskapsler</a>',
      headline: 'Informasjonskapsler og annonsering',
      intro:
        'Vi bruker pengene vi tjener fra de nydelige annonsene våre til hjelp med å betale regningene våre. Slik kan vi tilby fildelingstjenesten vår gratis.',
      'manage-cookies': 'Administrer informasjonskapsler',
      'partners-consent': 'Samtykke',
      'partners-features': 'Funksjoner',
      'partners-headline': 'Våre partnere',
      'partners-text':
        '<p>Her er en alfabetisk liste over forsiktig utvalgte partnere vi lar måle dataene dine, slik at vi kan spore og forbedre ytelsen.</p>',
      'preferences-headline': 'Administrer informasjonskapsler ',
      'preferences-text':
        '<p>Vi respekterer din rett til personvern og valgene dine vedrørende dine egne data. Vi må behandle noen av personopplysningene dine når du bruker verktøyene våre, men vi er forpliktet til en ansvarlig og verdibasert tilnærming til forretningsvirksomhet, teknologi og forholdet vårt til deg.</p>\n<p>Dette er grunnen til at vi går langt for å holde det digitale fotavtrykket ditt lite, trygt og under din kontroll.</p>\n<p>Som standard samler vi kun inn og behandler data når det er strengt nødvendig. Hvis du uansett ønsker å støtte tjenesten vår og holde WeTransfer gratis, kan du la oss dele informasjonen din med annonsepartnerne våre.</p>',
      'preferences-text-allow-cookies':
        'Tillat informasjonskapsler slik at vi og/eller partnerne våre kan:<br><br>',
      'purpose-description-first-intro':
        'For å annonsere for produkter på og utenfor nettstedet og appene våre, kan WeTransfer: ',
      'purpose-description-first-list':
        '<ul><li>Samle inn informasjon om hvordan du samhandler med nettstedene våre, slik som klikkeatferd og sider som ble besøkt, og (når mulig) kombinere denne informasjonen med data vi har samlet om deg, slik som e-postadressen for kontoen din</li><li>Bruke informasjonen vi samler inn for å gi deg tilbud og kampanjer over e-post, på nettstedene og appene våre, og på nettsteder og apper for tredjeparter. Vi kan for eksempel vise deg annonser for et av de andre produktene våre når du bruker WeTransfer Pro.</li></ul>',
      'purpose-description-second-intro':
        'For å annonsere for produkter på og utenfor nettstedet og appene våre, kan partnerne våre: ',
      'purpose-description-second-list':
        '<ul><li>Samle inn informasjon om hvordan du samhandler med nettstedene våre, slik som klikkeatferd og sider som ble besøkt, og (når mulig) kombinere denne informasjonen med data de har samlet om deg</li><li> Bruke informasjonen de samler inn for å gi deg tilbud og kampanjer over e-post, på nettstedene og appene deres, og på nettsteder og apper for tredjeparter de samarbeider med.</li></ul>',
      'purpose-title':
        'Annonser for produkter på og utenfor nettstedet og appene våre',
      'switch-by-partners': 'Fra partnere',
      'switch-by-we-transfer': 'Fra WeTransfer',
      text: '<p>Nettstedet vårt bruker <a href="%{href}">informasjonskapsler</a> som hjelper det til å fungere, lar oss analysere hvordan du samhandler med det og hjelper oss til å bedre ytelsen.</p>\n<p>Vil du også tillate informasjonskapsler fra annonsepartnerne våre, så vi kan tilpasse annonsene du ser samt fremme produkter fra WeTransfer og partnerne våre både på og utenfor nettstedene og appene våre?</p>',
      'text-panel':
        '<p>Nettstedet vårt bruker informasjonskapsler som hjelper det til å fungere, lar oss analysere hvordan du samhandler med det og hjelper oss til å bedre ytelsen.</p>\n<p>Vil du også tillate informasjonskapsler fra annonsepartnerne våre, så vi kan tilpasse annonsene du ser samt fremme produkter fra WeTransfer og partnerne våre både på og utenfor nettstedene og appene våre?</p>',
      'tos-experiment': {
        'cookie-intro':
          'Den enkleste måten å sende store filer på, mens du ser på utrolig kunst og prisvinnende annonser.',
        'cookie-text':
          'Nettstedet vårt bruker informasjonskapsler som hjelper det til å fungere, lar oss analysere hvordan du samhandler med det og hjelper oss med å bedre ytelsen. \nVed å godta informasjonskapslene, lar du oss vise deg tilpassede annonser. Har vi sagt nok om dem nå? (Informasjonskapsler!)',
      },
      trees: {
        'short-v': {
          subtitle:
            'Målet vårt er å gjøre verden til et vakrere sted, gjennom prisvinnende annonser som ikke kommer i veien og hjelper oss til å bidra til å gjenoppbygge undervannsvegetasjon.',
          title: 'Informasjonskapslene våre beskytter planeten',
        },
        subtitle:
          'Ved å godta informasjonskapslene våre, hjelper dere oss med å utvide løftet vårt til planeten. Bare i år har WeTransfer forpliktet seg til å plante over 175 000 trær, og vi har bare så vidt begynt. Dere kommer til å ha en positiv innvirkning bare ved å oppleve de prisbelønnede annonsene våre. ',
        text: 'Nettstedet vårt bruker informasjonskapsler for å bedre ytelsen, tjenesten og for å bedre forstå hva dere trenger. Ved å godta informasjonskapsler fra tredjeparter, vil vi og partnerne våre kunne tilby mer relevante annonser på og utenfor nettstedene og appene våre.',
        title: 'Overfør idéer. <b>Forandre verden.</b>',
      },
    },
    pro_pass_upsell_one: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_collect',
      text: 'Lås opp Collect Pro',
      title: 'Lagre og del inspirasjon mens du er på farten',
    },
    pro_pass_upsell_three: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_three',
      text: 'Jeg vil vite mer',
      title: 'Paste® Pro og Collect Pro er nå inkludert i abonnementet ditt',
    },
    pro_pass_upsell_two: {
      href: 'https://pro.bywetransfer.com/pro-pass?utm_source=pro_pass&utm_medium=interstitial&utm_campaign=pro_pass_paste',
      text: 'Lås opp Paste® Pro',
      title: 'Gjør store ideer om til nydelige presentasjonsdekk',
    },
    terms_conditions: {
      experiment: {
        text: 'Du må samtykke til <a href="/legal/terms" data-route-type="plus">tjenestevilkårene våre</a> før du kan fortsette.',
        title: "Du er <span class='tc-title-exp'>nesten</span> ferdig",
        ustitle:
          "Velkommen til den enkleste måten å <span class='tc-title-exp'>sende store filer på.</span>",
      },
      title: 'Før vi starter …',
      text: 'For å fortsette, må du godta våre <a href="/legal/terms" data-route-type="plus">bruksvilkår</a> og <a href="/legal/privacy" data-route-type="plus">retningslinjer for informasjonskapsler</a>. Informasjonskapslene våre er for funksjons- og analyseformål mens tredjeparters informasjonskapsler er for annonseformål.',
      language: 'Språket ditt er satt til',
      button: 'Godta',
    },
    upsell_pricing: {
      text: 'Sammenlign abonnementer',
      title: 'Lyst til å sende større overføringer?',
      receiving: {
        title: 'Lyst til å få mest mulig ut av WeTransfer?',
      },
    },
    welcome: {
      card1:
        'Send og motta overføringer på %{transfer_limit}, med én <strong>delt oversikt</strong>',
      card2:
        'Lever arbeid fra teamets <strong>tilpassede WeTransfer-side</strong>',
      card3:
        'Samarbeid på decks i <strong>Paste®</strong> og boards i <strong>Collect</strong>',
      cta: 'Da setter vi i gang',
      headline: 'Du er med i teamet, <strong>%{first_name}!</strong>',
      'opt-in':
        'Jeg vil høre historiene om kreativitet og siste nytt om WeTransfer',
    },
    form: {
      num_files: {
        one: 'La til %{count} fil, %{remaining} mangler',
        other: 'La til %{count} filer, %{remaining} mangler',
      },
      add_files: 'Last opp filene dine',
      more_files: 'Legg til flere filer',
      available_space: 'Legg til opptil %{size}',
      message: 'Melding',
      from: 'Din e-postadresse',
      to: 'Mottakers e-postadresse',
      other_recipients: {
        one: '+ %{count} til',
        other: '+ %{count} til',
      },
      reset_forward: 'Avbryt videresendingen',
      drop_files: 'eller dra og slipp',
      files_count: {
        one: '%{count} fil lagt til – totalt %{fileSize}',
        other: '%{count} filer lagt til – totalt %{fileSize}',
      },
      select_folder: 'Eller velg en mappe',
    },
    progress: {
      title: 'Overfører …',
      title_cancel: 'Vil du avbryte overføringen?',
      uploaded: '%{sent} av %{total} er lastet opp',
      remaining: {
        minutes: {
          zero: 'Det er mindre enn 1 minutt igjen',
          one: 'Det er ca. 1 minutt igjen',
          other: 'Det er ca. %{count} minutter igjen',
        },
        hours: {
          one: 'Det er ca. 1 time igjen',
          other: 'Det er ca. %{count} timer igjen',
        },
      },
      document_title: '%{percentage}% - Overfører …',
      meta: {
        email: {
          one_file_one_recipient:
            'Sender %{filesCount} fil til %{recipientsCount} person',
          one_file_other_recipients:
            'Sender %{filesCount} fil til %{recipientsCount} personer',
          other_files_one_recipient:
            'Sender %{filesCount} filer til %{recipientsCount} person',
          other_files_other_recipients:
            'Sender %{filesCount} filer til %{recipientsCount} personer',
        },
        link: {
          one: 'Sender %{count} fil',
          other: 'Sender %{count} filer',
        },
      },
    },
    complete_link: {
      title: 'Ferdig!',
      text: 'Kopier nedlastingskoblingen din eller <a href="/transfer/progress">se hva den inneholder</a>',
      text_copied: 'Koblingen er kopiert til utklippstavlen din',
      text_manual_copy:
        'Koblingen er klar\nTrykk på %{shortcut} for å kopiere den til utklippstavlen ',
      document_title: 'Ferdig!',
      text_pre_qr: 'Copy your download link or',
      text_get_qr: 'Get QR code',
      text_see_qr: 'See QR code',
    },
    storage_full_block: {
      information_detail_link: 'a lot of files',
      information_detail_text: 'You’re storing ',
      instruction_detail_link: 'request a storage boost',
      instruction_detail_text: 'Please <b>clean up some old files</b> or ',
      title: 'Hey, big sender',
      cta: 'Clean up',
    },
    complete_forward: {
      title: 'Overføringen din ble videresendt',
    },
    complete_email: {
      title: 'Ferdig!',
      text: 'Det er sendt en e-post om overføring. Overføringen din er tilgjengelig i %{expires}. <a href="/transfer/progress">Se hva den inneholder</a>',
      text_no_expiry:
        'Det er sendt en e-post om overføring. <a href="/transfer/progress">Se hva den inneholder</a>',
      document_title: 'Sendt!',
      text_no_details:
        'Det er sendt en e-post om overføring. Overføringen din er tilgjengelig i %{expires}.',
      team_discovery_title: 'Overføringen er sendt!',
      team_discovery_text:
        'Overføringen er tilgjengelig for nedlasting i %{expires}',
    },
    failed: {
      title: 'Noe gikk visst galt',
      text: 'Overføringen funket visst ikke. Gjør et nytt forsøk',
    },
    pending: {
      title: 'Vi jobber med saken …',
      subtitle: 'Forbereder …',
    },
    downloading: {
      title: 'Henter filene dine …',
      text: 'Vi forbereder nedlastingen din nå',
    },
    downloaded: {
      title: 'Nedlastingen har startet',
      text: 'Når den er ferdig, skal filene være på datamaskinen din (vanligvis i nedlastingsmappen) ',
      download_links:
        'Vær oppmerksom på at koblingene i dette Board ikke vil vises – <a href="https://wetransfer.zendesk.com/hc/en-us/articles/115005062963" rel="external">les mer her</a>.',
    },
    expired: {
      title: 'Overføring utløpt',
      text: 'Beklager, men overføringen har utløpt og er ikke lenger tilgjengelig',
    },
    password: {
      title: 'Angi passordet',
      text: 'Du trenger passordet for å laste ned denne overføringen',
    },
    options: {
      transfer_type: 'Send som',
      password: 'Passord',
      password_placeholder: 'Angi passord',
      expiry: 'Utløper etter',
      expire_in: {
        '1w': '1 uke',
        '2w': '2 uker',
        '1m': '4 uker',
        never: 'Aldri',
        '14d': '2 uker',
        '28d': '4 uker',
        '365d': '1 år',
        '7d': '1 uke',
        '90d': '3 måneder',
      },
      email: 'e-post',
      link: 'kobling',
      email_transfer: 'Send e-postoverføring',
      transfer_link: 'Få overføringskobling',
    },
    buttons: {
      transfer: 'Overfør',
      forward: 'Vidersend',
      new_transfer: 'Send en fil?',
      cancel: 'Avbryt',
      cancel_no: 'Nei',
      cancel_yes: 'Ja',
      copy_link: 'Kopier kobling',
      ok: 'OK',
      done: 'Vil du sende mer?',
      team_discovery_done: 'Send ny overføring',
      retry: 'Prøv igjen',
      continue: 'Fortsett',
      download: 'Last ned',
      download_all: 'Last ned alle',
      back_to_home: 'Tilbake til startsiden',
      cleanup: 'Gå gjennom overføringene ',
      download_all_files: 'Last ned alle filer',
      help: 'Brukerstøtte',
      payment: 'Forny nå',
      complete_order: 'Gå til kassa',
      download_all_experiment: 'Last ned alle som en .zip-fil',
      download_experiment: 'Last ned fil',
      download_file: 'Last ned fil',
      download_zip: 'Last ned alle som en .zip-fil',
      get_link: 'Få en kobling',
      go_to_transfer: 'Gå til overføring',
      openinapp: 'Lagre med Wetransfer-appen',
      openinapp_experiment: 'Lagre med WeTransfer-appen',
      openincollectapp: 'Lagre med Collect App',
      get_a_link: 'Få en kobling',
    },
    account_expired: {
      text: 'Forny nå for å beholde alle fordelene du har som Pro-kontobruker, eller <a href="#signout">logg ut for å bruke gratistjenesten vår</a>.',
      title: 'Pro-kontoen din er utløpt',
    },
    invalid: {
      text: 'Vi finner ikke filene dine',
      title: 'Auda!',
      link: 'Finn ut mer',
    },
    outdated_browser: {
      text: 'WeTransfer støtter en rekke nettlesere, men denne er visst for gammel. Prøv å oppdatere den',
      title: 'Nettleseren din er utdatert',
    },
    spam: {
      text: 'Overføringen har blitt rapportert som søppelpost og ble slettet',
      title: 'Hmm …',
    },
    upsell: {
      text: 'Øk grensen',
      limit: 'Opptil %{limit} gratis',
      remaining: '%{remaining} gjenstår',
    },
    upsell_five: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaff deg WeTransfer Pro',
      title: 'Beskytt overføringene med passord for å få ekstra trygghet',
    },
    upsell_four: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaff deg WeTransfer Pro',
      title: 'Administrer overføringene dine både smartere og enklere',
    },
    upsell_one: {
      bubble: {
        button: 'Skaff deg Pro',
        text: 'Beskytt filene dine med passord, og velg dine egne utløpsdatoer.',
        title: 'Ønsker du oppgradert overføring?',
        text_experiment:
          'Pro lar deg angi passord og utløpsdatoer for overføringene dine.',
      },
      href: 'https://facebook.com/wetransfer',
      text: 'WeTransfer på Facebook',
      title: 'Bli med i WeTransfer-fellesskapet på Facebook',
    },
    upsell_three: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaff deg WeTransfer Pro',
      title: 'Sett personlig særpreg på WeTransfer-profilen din',
    },
    upsell_two: {
      href: '/pro?trk=WT202006_post_transfer_inapp_message',
      text: 'Skaff deg WeTransfer Pro',
      title: 'Gå for større, bedre, kraftigere og raskere',
    },
    account_inactive: {
      text: 'Fullfør registreringen for å komme i gang med Pro',
      title: 'Kontoen din er\nikke aktiv ennå ',
      tiers: {
        text: 'Fullfør betalingen for å komme i gang med %{plan}.',
        title: 'Abonnementet ditt er ikke aktivt ennå',
      },
    },
    add_items: {
      files: 'Filer',
      folders: 'Mapper',
    },
    complete: {
      open_panel: '<a href="/transfer/progress">Se hva den inneholder</a>?',
    },
    details: {
      button: {
        dismiss: 'Avvis',
      },
    },
    download_preview: 'Last ned fil',
    error: {
      expired: {
        link: 'Ta kontakt med kundestøtteteamet vårt',
        text: 'Auda, ser ut til at overføringen din allerede har utløpt.\nHøres dette galt ut?',
        title: 'Overføring utløpt',
      },
    },
    item: {
      details: {
        folder: 'Mappe',
      },
    },
    items: {
      zero: 'tom',
      one: '%{count} element',
      other: '%{count} elementer',
    },
    mobile: {
      button: {
        back: 'Tilbake',
        cancel: 'Start på nytt',
        next: 'Neste',
      },
      email: {
        title: 'Legg til e-postadresser',
      },
      message: {
        placeholder: 'Legg til en melding i overføringen din',
        title: 'Melding',
      },
      options: {
        email: 'Send en e-post',
        'email-description':
          'Send overføringen din med en enkel e-postmelding, så forteller vi deg når den har blitt lastet ned.',
        link: 'Få en kobling',
        'link-description':
          'Gjør om filene dine til en kobling og del den slik du selv ønsker.',
      },
    },
    recaptcha: {
      button: '100 % menneske',
      text: 'Vi må bare forsikre oss om at du ikke er en robot (ikke vondt ment)',
      title: 'Du er nesten ferdig!',
    },
    upsell_survey: {
      href: 'https://www.surveymonkey.com/r/2HTSNSZ',
      text: 'Hjelp oss',
      title: 'Kan vi spørre deg om noe om måten du jobber på?',
    },
    'verification-code': 'Godkjenningskode',
    verify: {
      button: 'Start overføring',
      text: 'Sjekk innboksen din for en bekreftelseskode, og sleng den inn nedenfor',
      title: 'Du har post',
      'verification-code': 'Bekreftelseskode',
    },
    'account-verification-failed': {
      body: 'Vi sliter med å bekrefte e-postadressen din. Send en ny kobling for å prøve igjen.',
      cta: 'Send en ny kobling?',
      title: 'Noe gikk galt',
    },
    'cookie-banner': {
      'button-accept': 'Greit',
      'button-decline': 'Nei',
      text: 'Vi bruker <a href="%{href}">informasjonskapsler</a> som bidrar til at nettstedet fungerer, lar oss analysere hvordan brukerne samhandler med det og hjelper oss til å forbedre det. Ønsker du å også tillate informasjonskapsler fra tredjeparter, slik at du får tilpassede annonser?',
    },
    'cookie-manager': {
      analytical: {
        description:
          'Vi bruker analytiske informasjonskapsler til å hjelpe oss å forstå hvordan du bruker WeTransfer. De gjør det mulig for oss å A/B-teste nye funksjoner, sikre at alt fungerer som det skal og stoppe roboter og skadelig atferd, som spam. Disse informasjonskapslene kan inkludere tredjeparts informasjonskapsler som behandler personopplysninger. ',
        title: 'Analytiske informasjonskapsler',
      },
      clear: {
        'clear-all-cookies': 'Fjern alle informasjonskapsler',
        description:
          'Du kan fjerne alle dataene dine fra informasjonskapslene våre. <a href="mailto:support@wetransfer.com">Kontakt støtteteamet vårt</a> med permanente anonymitetsforespørsler.',
        title: 'Fjern informasjonskapsler',
        warning:
          'Du blir logget av WeTransfer etter at informasjonskapslene er fjernet. Dette har ingen innvirkning på overføringer i kontoen din.',
      },
      functional: {
        description:
          'Vi bruker funksjonelle informasjonskapsler til å skape en sømløs opplevelse for deg på WeTransfer. De er nødvendige for å bruke tjenesten vår.',
        title: 'Funksjonelle informasjonskapsler',
      },
      'not-yet-set':
        'Det ser ikke ut til at du har gitt oss preferansene dine angående informasjonskapsler ennå. Lukk dette panelet og angi preferansene dine. Du kan når som helst endre det her senere.',
      'save-and-reload': 'Lagre innstillinger',
      tracking: {
        description:
          'Vi bruker informasjonskapsler for annonsering på tjenesten vår til å måle hvor vellykket den kommersielle, redaksjonelle og salgsfremmende innsatsen vår er. Informasjonskapsler for annonsering plasseres ikke på sidene som gir informasjon om merkevaren og produktene våre. Informasjonskapsler for annonsering gjør at vi kan registrere at du har klikket på en bestemt reklame, for eksempel. Hvis informasjonskapsler plassert av tredjeparter også er plassert på andre domener og nettsteder, kan annonsører følge atferden din på over hele internett, men WeTransfer har ikke tilgang til og kan ikke bruke noen av disse personopplysningene som kan samles inn. Derfor henviser vi deg til personvernretningslinjene til de aktuelle tredjepartene.',
        title: 'Informasjonskapsler for annonsering',
      },
    },
    'email-verification-resend': {
      account: {
        error: 'Auda, noe gikk galt',
        'error-email-exists':
          'Oisann, ser ut til at denne e-posten allerede er i bruk',
        'throttle-error':
          'Neimen, nå har vi sendt deg for mange e-poster. Vent %{throttle_time} før du ber om en ny kode.',
      },
      back: 'Tilbake til bekreftelseskode',
      body: 'Ble dette riktig? Dette er e-postadressen du bruker for WeTransfer.',
      email: 'E-post',
      error: 'Auda, noe gikk galt',
      'error-email-exists':
        'Oisann, ser ut til at denne e-posten allerede er i bruk',
      submit: 'Send på nytt',
      'throttle-error':
        'Beklager, du har prøvd for mange ganger. Start overføringen på nytt.',
      'throttle-error-action': 'Start på nytt',
      'throttle-error-link':
        'Neimen, nå har vi sendt deg for mange e-poster. Vent %{throttle_time} før du ber om en ny e-post.',
      title: 'Kontroller e-posten din',
    },
    'email-verification-success': {
      body: 'Nå kan mottakerne stole på at det virkelig var du som sendte overføringene dine.',
      free_signup: 'Opprett en gratiskonto',
      onboarding_body:
        'High five, du er registrert! Klar til å velge din egen URL og bakgrunner?',
      onboarding_title: 'Velkommen til<br/>WeTransfer Pro!',
      send_files: 'Send filer',
      start_onboarding: 'Da begynner vi',
      title: 'Kontoen din har blitt bekreftet!',
      upsell: 'Ikke lyst til å bekrefte e-postadressen din hver gang?',
      verified_sender_tooltip:
        'E-postadressen din er bekreftet, og det betyr at andre kan stole på at overføringene ble sendt av deg. For å endre denne e-postadressen må du oppdatere <a href="%{href}">personopplysningene</a> dine.',
      verified_sender_tooltip_icon:
        'Du har bekreftet e-postadressen din. Det betyr at andre kan stole på at overføringene er blitt sendt av deg.',
    },
    'email-verification': {
      account: {
        'error-expiry-time':
          'Oisann, den koden er feil eller utløpt. Koder er kun aktive i %{expiry_time} etter at de ble sendt.',
        'error-expiry-time-action': 'Få en ny kode',
        'throttle-error':
          'Du har angitt feil eller utløpt kode for mange ganger. Vent %{throttle_time} før du ber om en ny kode.',
      },
      back: 'Gå tilbake',
      body: 'Vi har sendt en verifikasjonskode til <strong title="%{account_email}">%{account_email}</strong> for å forsikre oss om at du faktisk er deg. (husk å sjekke søppelposten).',
      body_link:
        'Bare kjapt, for å være sikker på at det virkelig er deg.<br/><br/>Vi sendte en bekreftelseskobling til <strong title="%{account_email}">%{account_email}</strong> (hvis du ikke finner den, se i spam).',
      error: 'Oisann, den koden er feil eller utløpt',
      'error-expiry-time':
        'Oisann, den koden er feil eller utløpt. Koder er kun aktive i %{expiry_time} etter at de ble sendt.',
      'error-expiry-time-action': 'Få en ny kode',
      resend: 'Fikk du ikke en e-post?',
      submit: 'Bekreft',
      'throttle-error':
        'Beklager, du har prøvd for mange ganger. Start overføringen på nytt.',
      'throttle-error-action': 'Start på nytt',
      title: 'Bekreft e-postadressen din!',
      'verification-code': 'Angi bekreftelseskode',
    },
    'force-account-verification': {
      body: 'Vi sender deg en kobling på e-post, for å bekrefte e-postadressen du bruker for WeTransfer.',
      cta: 'Send e-post',
    },
    'marketing-email-prompt': {
      body: 'Sånn til slutt – ønsker du å motta nyheter og produktoppdateringer fra WeTransfer?',
      skip: 'Nei takk',
      subscribe: 'Ja, hold meg oppdatert',
      title: 'Du er bekreftet!',
    },
    'terms_conditions-no-cookies': {
      text: 'For å fortsette, bekreft at du godtar våre <a href="/legal/terms?from_home" data-route-type="plus">bruksvilkår</a>.',
    },
    mobile_web: {
      ios_banner_prompt: 'Få filene dine i WeTransfer-appen',
      ios_banner_prompt_send: 'Send filer raskt og enkelt',
      tnc_subtitle: 'Den enkleste måten å sende store filer på',
    },
  },
  account: {
    legend: {
      plan: 'Abonnement',
      save: 'spar %{amount} %',
      subscription: 'Abonnement',
      summary: 'Oppsummering av bestilling',
      wetransfer_premium: 'WeTransfer Premium',
    },
    'verify-info': 'Hvorfor vi ber deg om å bekrefte e-postadressen din',
    workspace: {
      default_workspace: '%{name} sitt arbeidsområde',
      your_workspace: 'Arbeidsområdet ditt',
    },
    consent_manager: {
      data_opt_in: {
        title: 'Personvernvalg',
        subtitle: 'Administrer dataene dine',
        p1: 'Vi prøver alltid å gi deg en best mulig opplevelse, selv med annonseringen vår.',
        p2: 'Vi vil gjerne bruke dataene du velger å dele, som e-postadressen din, til å forstå hva slags innhold du liker best og til å vise deg (og andre som deg) WeTransfer-annonser som er mest mulig skreddersydd til dine behov.',
        p3: 'Alt du skaper og deler på WeTransfer, forblir privat for deg – vi hverken leser det eller bruker det til annonsering.',
        p4: 'Hvis du velger å dele den med oss, forblir denne informasjonen sikker for alltid.',
        control_label:
          'La WeTransfer bruke dataene du deler, som e-postadressen og arbeidsfeltet ditt, til å skreddersy annonsene du ser både på og utenfor nettstedene våre.',
      },
      vertical_nav: {
        terms_of_service: 'Vilkår for bruk',
        privacy_and_cookie_statement:
          'Erklæring om personvern og informasjonskapsler',
        your_privacy_choices: 'Personvernvalg',
        notice_and_takedown_policy: 'Retningslinjer for varsel og fjerning',
        responsible_disclosure_policy:
          'Retningslinjer for ansvarlig offentliggjøring',
        advertising_terms_and_conditions: 'Vilkår for annonsering',
      },
    },
  },
  account_onboarding_navigation: {
    cta: 'Lukk og gå til sending av filer',
  },
  account_start_screen: {
    'collect-description':
      'Lagre all inspirasjonen din på ett sted, uansett om du er på telefonen, den bærbare PC-en eller nettbrettet.',
    'collect-title': 'Gå til Collect',
    'paste-description':
      'Skap nydelige lysbilder på sekunder, med presentasjonsstokker som designer seg selv.',
    'paste-title': 'Gå til Paste®',
    title: 'Tre verktøy. Én konto. Uendelige muligheter.',
    'transfer-cta': 'Da gjør vi det',
    'transfer-description':
      'Gjør et godt førsteinntrykk hver gang noen laster ned filene dine. Klar til å velge URL og bakgrunner?',
    'transfer-title': 'Lag din egen WeTransfer-side',
  },
  account_welcome_screen: {
    'pro-title': 'Velkommen til WeTransfer Pro, <strong>%{name}!</strong>',
    accept: 'Ja, takk',
    'accept-short': 'Greit',
    body_1:
      'Har du lyst til å høre historier om kreativitet og få siste nytt fra WeTransfer?',
    body_2: '(Du kan uansett melde deg av senere.)',
    decline: 'Nei, takk',
    'decline-short': 'Nei takk',
    title: 'Velkommen til WeTransfer, <strong>%{name}</strong>',
  },
  cookie_wall_paid: {
    button: {
      accept: 'Godta informasjonskapsler',
      deny: 'Avvis informasjonskapsler',
      manage: 'Administrer informasjonskapsler',
    },
    description:
      'Vi bruker vanlige informasjonskapsler og analytiske informasjonskapsler for å sikre en flott opplevelse, og tredjeparts informasjonskapsler til reklameformål.',
    heading: 'Oppdag den enkleste måten å sende store filer på',
    snippet: 'Velkommen til WeTransfer',
  },
  dropzone: {
    pro: {
      title: 'En, to, tre<br><span>slipp</span>',
    },
    title: 'En, to, tre – slipp',
    text: 'Last opp filer eller mapper ved å slippe dem i dette vinduet',
  },
  form: {
    account: {
      billing_address: 'Fakturaadresse',
      billing_cta: 'Gå til betaling',
      billing_title: 'Betalingsinformasjon',
      legend: {
        details: 'Din betalingsinformasjon',
        coupon_code: 'Legg til en rabattkode',
        free_plus: 'Få gratis Pro-konto',
      },
      label: {
        year_label: 'Årlig',
        year_sublabel: 'Mest for pengene: spar %{discount_rate} %',
        month_label: 'Månedlig fakura',
        month_sublabel: 'Løpende fakturering',
        email: 'E-postadresse',
        not_required: '(valgfritt)',
        current_password: 'Gjeldende passord',
        new_password: 'Nytt passord',
        repeat_new_password: 'Bekreft nytt passord',
        password: 'Passord',
        password_confirm: 'Bekreft passordet',
        full_name: 'Fullt navn',
        company: 'Bedrift',
        street_and_number: 'Adresse',
        city: 'Poststed',
        zipcode: 'Postnummer',
        country_code: 'Land',
        vat_number: 'MVA',
        coupon_code: 'Rabattkode',
        family_name: 'Etternavn',
        given_name: 'Fornavn',
        state_code: 'Stat',
      },
      description: {
        password: 'Velg et passord som består av minst 6 tegn',
        vat_number:
          'Bedrifter i Nederland må betale 21 % merverdiavgift. Hvis virksomheten din driftes fra et annet EU-land enn Nederland, fjerner vi merverdiavgiften fra fakturaen din hvis du fyller inn bedriftsinformasjonen din og det europeiske skatte-ID-nummeret ditt.\n \nHvis bedriften din er utenfor EUs MVA-område, slipper du å betale MVA, men vi trenger likevel betalingsinformasjonen din.',
      },
      error: {
        email: {
          blank: 'Angi e-postadressen din',
          invalid: 'Angi en gyldig e-postadresse',
          taken: 'Denne e-postadressen er allerede i bruk',
          taken_login:
            'Det ser ut til at du allerede har en konto. <a class="form-notification__message-link" href="%{login_url}">Vil du logge på?</a>',
        },
        current_password: {
          invalid: 'Passordet ble ikke gjenkjent',
          blank: 'Angi nåværende passord',
        },
        password: {
          blank: 'Angi det nye passordet',
          too_short: 'Passordet må bestå av minst 6 tegn',
        },
        password_confirm: {
          blank: 'Bekreft det nye passordet',
          confirm: 'Passordene samsvarer ikke',
        },
        full_name: {
          blank: 'Angi fullt navn',
          too_short: 'Oisann, navnet ditt må ha minst tre tegn',
        },
        street_and_number: {
          blank: 'Angi adressen din',
        },
        city: {
          blank: 'Angi poststedet ditt',
        },
        zipcode: {
          blank: 'Angi postnummeret ditt',
        },
        country_code: {
          inclusion: 'Kontroller stavingen din, eller prøv et annet land',
          blank: 'Angi landet ditt',
        },
        vat_number: {
          vat_number: 'Angi et gyldig MVA-nummer',
        },
        terms_of_service: {
          accepted: 'Godta vilkårene for å fortsette',
        },
        no_results: 'Kontroller stavingen din, eller prøv et annet land',
        convert: {
          expired:
            'Beklager, men overføringen har allerede utløpt og kan ikke lagres. Visste du at WeTransfer Pro lar deg beholde overføringer så lenge du vil? Les mer her.',
        },
        coupon_code: {
          coupon_code: 'Angi en gyldig rabattkode',
        },
        no_state_results: 'Er dette en stat?',
      },
      complete_order: 'Fullfør bestillingen',
      terms_conditions:
        'Jeg godtar <a href="/legal/terms" %{options}>tjenestevilkårene</a>, og har lest <a href="/legal/privacy" %{options}>erklæringen om personvern og informasjonskapsler</a>',
      signup_for_plus: 'Registrer deg for WeTransfer Pro',
      account_cta: 'Kom igjen!',
      signup_for_account: 'Registrer deg for en WeTransfer-konto',
      'email-verification-not-verified-link':
        'Bekreft e-postadressen din. Sjekk e-posten vi sendte deg, eller <button type="button" class="button button--link">be om en ny</button>.',
      'email-verification-resend': {
        error: 'Auda, noe gikk galt',
        info: 'Ny kode sendt! Se i innboksen din',
        info_link: 'En ny e-post ble sendt! Sjekk innboksen din',
        'throttle-error':
          'Neimen, nå har vi sendt deg for mange e-poster. Vent %{throttle_time} før du ber om en ny kode.',
      },
      'force-account-verification': {
        message: 'Bekreft e-postadressen din, så vi vet at det er deg.',
      },
      marketing_opt_in:
        'Jeg ønsker å få nyheter og oppdateringer fra WeTransfer',
      sso: {
        header: 'Personopplysninger',
        password_reset: {
          button: 'Send e-post',
          instructions:
            'Trenger du litt forandring (av passord)? Null problem. Bare klikk på knappen nedenfor, så sender vi en e-post til <span>%{email}</span> med en kobling for å endre passordet ditt.',
          success: 'E-posten er sendt! Sjekk innboksen din.',
          title: 'Bytt passord',
        },
        wrong_user: 'Ikke deg? Logg av',
      },
    },
    payment_cancel: {
      submit: 'Bekreft',
      client_request:
        'En klient ba meg bruke WeTransfer, og nå trenger jeg det ikke',
      different_tool: 'Jeg fant et annet verktøy',
      extra_features: 'Jeg trenger ekstra funksjoner som dette ikke tilbyr',
      not_enough_storage: 'Det er ikke nok lagringsplass for min del',
      not_often_large_files: 'Jeg sender ikke store filer ofte nok',
      other: 'Annet',
      other_more: 'Kan du si mer',
      skip: 'Hopp over og avbryt abonnementet',
      temp_project:
        'Jeg trengte bare å overføre store filer for et midlertidig prosjekt',
      too_expensive: 'Jeg synes det er for dyrt',
    },
    payment_cancel_reason: {
      skip: 'Jeg vil ikke gi tilbakemelding',
    },
    profile: {
      label: {
        profile_title: 'Profilnavn',
        wallpaper_link: 'Nettadressen som bakgrunnene skal kobles til',
      },
      error: {
        subdomain_name: {
          too_short:
            'Vi har ingenting imot minimalisme, men WeTransfer URL-en din må bestå av minst 2 tegn',
          domain_name: 'Beklager, men noen har allerede kapret dette navnet',
          invalid:
            'Dette ble litt i merkeligste laget … WeTransfer URL-en din kan kun inneholde bokstaver og tall (samt bindestreker mellom dem)',
          taken: 'Beklager, men noen har allerede kapret dette navnet',
        },
        subdomain: {
          too_short: 'Fortsett til minst to tegn',
          too_long: 'Oi, hold deg til under 63 tegn',
          invalid:
            'Nei, det blir for rart – WeTransfer-URL-adressen kan bare inneholde bokstaver og tall (eller en bindestrek, hvis den står mellom disse)',
          domain_name: 'Denne URL-adressen er allerede i bruk',
        },
        default_recipient_email: {
          invalid: 'Angi en gyldig e-postadresse',
        },
        wallpaper_link: {
          invalid: 'Angi en gyldig nettadresse',
        },
      },
      success: {
        subdomain: {
          updated: 'URL-adressen din er oppdatert',
          available: 'Gode nyheter: Denne URL-adressen er tilgjengelig',
        },
      },
      change_background: 'Last opp bakgrunn',
      delete_avatar: 'Slett avatar',
      delete_background: 'Slett bakgrunn',
      description: {
        title: 'Psst, hold det til under 150 tegn, så det ikke faller av siden',
        wallpaper_link: 'Bakgrunnene dine kobler til denne nettadressen',
        recipient_email_locked:
          'Filer sendt gjennom profilen din, går bare til denne e-postadressen',
      },
      upload_avatar: 'Last opp en avatar',
      use_email_background_checkbox_label:
        'Bruk denne bakgrunnen for alle overføringer som sendes gjennom profilen min',
      account_email_checkbox: 'Vis e-postadresse på profil',
      default_recipient_email_info:
        'Du kan endre denne e-postadressen fra den <a href="/account">personlige informasjonen</a> din',
      change_subdomain: {
        message:
          'Vil du endre URL-adressen din til <a href="%{url}">%{subdomain}.wetransfer.com</a>? Din forrige blir tilgjengelig med en gang.',
        confirm: 'Ja, bytt URL-adresse',
        cancel: 'Gå tilbake',
      },
    },
    fill_in_password: 'Angi passordet ditt for å lagre endringene',
    select_all: 'Velg alle',
    deselect_all: 'Velg bort alle',
    save_changes: 'Lagre endringene',
    save: 'Lagre',
    submitting: 'Sender …',
    cancel: 'Avbryt',
    forward: 'Videresend',
    proceed: 'Fortsett',
    delete: 'Slett',
    onboarding: {
      placeholder: {
        subdomain_name: 'velg-et-bra-profilnavn',
      },
      validated: {
        subdomain_name: 'Gode nyheter: domenet er ledig',
      },
    },
    confirm_leave:
      'Hvis du forlater siden, mister du alle endringer som ikke er lagret. Vil du fortsette?',
    unsaved_changes:
      'Vil du forlate siden? Du mister alle endringer som ikke er lagret.',
    contact: {
      add_contact: 'Legg til kontakt',
      error: {
        email: {
          duplicate: 'Du har allerede denne e-postadressen i kontaktlisten din',
          invalid: 'Angi en gyldig e-postadresse',
        },
      },
      label: {
        company: 'Bedrift',
        email: 'E-postadresse',
        name: 'Navn',
      },
    },
    error: {
      current_password: {
        blank: 'Angi nåværende passord',
        invalid: 'Passordet ble ikke gjenkjent',
      },
      email: {
        blank: 'Angi e-postadressen din',
        duplicate: 'Du har allerede denne e-postadressen i kontaktlisten din',
        invalid: 'Angi en gyldig e-postadresse',
        taken: 'Denne e-postadressen er allerede i bruk',
      },
    },
    leave: 'Forlat siden',
    resetpassword: {
      button: {
        request_submit: 'Send meg en e-post',
        reset_submit: 'Lagre det nye passordet',
      },
      label: {
        confirm_new_password: 'Bekreft det nye passordet',
        email: 'E-postadresse',
        new_password: 'Nytt passord',
      },
      legend: {
        request_description:
          'Er du låst ute? Vi sender deg instruksjoner om hvordan du tilbakestiller passordet og får alt på stell igjen.',
        request_title: 'Har du glemt passordet ditt?',
        reset_description: 'Angi et nytt passord for å logge deg på igjen',
        reset_title: 'Velg et nytt passord',
        request_description_success_or_article:
          'Dersom du har en WeTransfer-konto, sendte vi deg instruksjoner om hvordan du tilbakestiller passordet ditt. Hvis du ikke får en e-post fra oss i løpet av de neste ti minuttene, kan du lese denne<a href="https://wetransfer.zendesk.com/hc/en-us/articles/360033809331" rel="external">Hjelpesenter-artikkelen</a>.',
      },
    },
    signin: {
      button: {
        submit: 'Logg inn',
      },
      label: {
        email: 'E-postadresse',
        password: 'Passord',
        remember_me: 'Husk meg',
      },
      link: {
        forgot_password: 'Har du glemt passordet?',
      },
      title: 'Logg på',
    },
    stay_on_page: 'Bli værende på siden',
    close_panel: 'Lukk',
    go_back: 'Gå tilbake',
    labels: {
      email: 'E-postadresse',
    },
    plan: {
      change: {
        month: 'Månedlig (%{price} %{currency})',
        title: 'Endre abonnementet',
        year: 'Årlig (%{price} %{currency})',
      },
      change_plan: 'Endre betalingsplan',
      month: {
        copy: 'Løpende fakturering',
        label: 'Månedlig',
        'label-payment': 'Månedlig betaling',
        'sub-label': 'Én faktura hver måned',
        title: 'WeTransfer Pro: månedlig betaling',
      },
      title: 'Gi ideene dine premium-behandlingen de fortjener',
      year: {
        discount: 'Spar %{rate} % (hurra!)',
        'label-payment': 'Årlig betaling',
        'sub-label': 'Slik sparer du 17 %. Wow!',
        title: 'WeTransfer Pro: årlig betaling',
      },
      your_order: 'Din bestilling',
    },
    save_and_continue: 'Lagre og fortsett',
    upgrade: null,
    fill_in_password_two_factor_authentication:
      'Skriv inn passordet ditt for å fortsette',
  },
  mobileweb: {
    'app-upsell': {
      cta: {
        false: 'Ikke nå',
        true: 'Åpne i WeTransfer-appen',
      },
      headline: 'Hvorfor ikke tenke større?',
      headline2: 'Vis filer i appen?',
      subheader: 'Send og motta 200 GB med WeTransfer Pro',
      subheader2:
        'Vis filer før du last dem ned. Send og motta overføringer, spor nedlastinger og bli varslet.',
    },
  },
  panel: {
    warning: {
      account_expired_subtitle_tier:
        'Forny nå for å fortsette å bruke alle fordelene til %{tier}-kontoen din',
      account_expired_title_tier: '%{tier}-kontoen din er utløpt',
      account_inactive_title_tier: 'Klar til å starte med %{tier}',
      account_inactive_action: 'Ja, fortsett',
      account_inactive_subtitle:
        'Bare ett trinn til, så er du ferdig. Har du ombestemt deg? Det er greit—',
      account_inactive_title: 'Klar til å bli Pro?',
      account_subscription_action: 'Forny nå',
      account_subscription_expired: 'Pro-kontoen din er utløpt',
      account_subscription_subtitle:
        'Forny nå for å unngå at overføringene dine, de personlige bakgrunnene samt nettadressen din slettes om kort tid!',
      account_expired_action: 'Forny nå',
      account_expired_subtitle:
        'Forny nå for å beholde alle fordelene du har som Pro-kontobruker',
      account_expired_title: 'Pro-kontoen din er utløpt',
      expired_transfer_subtitle:
        'Filene er ikke lenger tilgjengelige. Du kan fjerne informasjonen fra overføringsoversikten din <a>her</a>.',
      expired_transfer_title: 'Overføringen har utløpt',
      account_email_verify_logged_out:
        'Logg på for å bekrefte e-postadressen din',
      account_inactive_sublink: 'kanseller bestillingen din',
      email_unverified_mobile_cta: 'Klar til å bekrefte',
      email_unverified_text:
        "Vi har sendt en bekreftelseskode til %{email}<a href='%{href}'>. Er ikke dette deg?</a>",
      email_unverified_text_link:
        "Vi har sendt en e-post til %{email}. <a href='%{href}'>Er det ikke deg?</a>",
      email_unverified_title: 'Bekreft e-postadressen din',
      'force-account-verification': {
        body: 'Vi sender en kobling på e-post, for å bekrefte at det er deg.',
      },
      'receiving-email':
        'Varsko her! Vi har erstattet %{receiving_email} i profilen din. Dette betyr at nye overføringer kun dukker opp i overføringsoversikten din dersom de er sendt til %{account_email}. For å endre dette, kan du når som helst oppdatere den <a href="/account">personlige informasjonen</a> din.',
    },
    design:
      'Du har sikkert lagt merke til at vi har endret litt på ting og tang – blant annet etter ønske fra deg. Kos deg med å utforske det nye og (etter vår mening) bedre nettstedet vårt, og gi oss gjerne tilbakemelding om hva du synes.',
    loading_error:
      'Oi, det er visst problemer med å laste inn siden akkurat nå.\nVi gir ikke opp, men du kan også se om det hjelper å <a href="%{path}">laste inn siden på nytt</a>. ',
    redesign_notice:
      'Du har sikkert lagt merke til at vi har <a href="/about/redesign">endret litt på ting og tang</a> – blant annet etter ønske fra deg. Kos deg med å utforske det nye og (etter vår mening) bedre nettstedet vårt, og <a href="/contact" rel="external">send oss tilbakemelding her<a/>.',
    return_to: 'tilbake til %{pageName}',
    close: 'Lukk panelet',
    cookie: {
      accept: 'Greit',
      text: 'Vi bruker informasjonskapsler. Les <a href="/legal/terms">det juridiske tullballet</a>.',
    },
    footer: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      jobs: 'Stillinger',
      press: 'Media',
      terms: 'Vilkår',
      twitter: 'Twitter',
      youtube: 'YouTube',
    },
  },
  upsell_tiers: {
    button: 'Oppgrader',
    free_limit:
      'Du kan ikke sende mer enn 2 GB om gangen. Lyst til å sende større overføringer?',
    compare_plans: {
      button: 'Sammenlign abonnementer',
      text: 'Du kan oppgradere abonnementet til å overføre mer enn 2 GB av gangen.',
      title: 'Har du flere filer å sende?',
    },
    mobile: {
      cta: 'Les mer',
      header: 'Få det beste WeTransfer har å tilby',
      upsell_enjoy: 'Dra nytte av mer lagringsplass',
      upsell_one: 'Send større overføringer',
      upsell_two: 'Sett et personlig preg på WeTransfer-siden din',
    },
    pro_limit:
      'Du kan ikke sende mer enn 200 GB om gangen. Lyst til å sende overføringer av alle størrelser?',
  },
  upsell_tiers_one: {
    text: 'Lyst til å angi passord og utløpsdatoer for overføringene dine?',
  },
  upsell_tiers_three: {
    text: 'Lyst til å sende overføringer til mer enn %{email_limit} e-postadresser om gangen?',
    title: 'Det er én for mye',
  },
  browser: {
    assets_failed: {
      text: 'Viktige deler av nettstedet vårt ble ikke lastet inn.\nDet kan hende de blokkeres av brannmuren din, proxy- eller nettleserinnstillingene.\nPrøv å laste inn siden på nytt, eller ta kontakt med <a href="https://wetransfer.zendesk.com" rel="external">brukerstøtte</a>.  ',
      title: 'Å nei …',
    },
    javascript_needed:
      'Du må ha en JavaScript-aktivert nettleser for å kunne bruke WeTransfer.',
  },
  languages: {
    en: 'Engelsk',
    nl: 'Nederland',
  },
  shortcuts: {
    cmd_alt_l: '⌘-Alt-L',
    cmd_j: '⌘-J',
    cmd_c: '⌘-C',
    cmd_shift_j: '⌘-Shift-J',
    control_alt_l: 'Ctrl-Alt-L',
    control_j: 'Ctrl-J',
    control_c: 'Ctrl-C',
  },
  discount: {
    billing_page: {
      legal_notice:
        'Dette tilbudet er tilgjengelig til %{end_date}. Rabatten gjelder for det første året av %{user_tier}. Deretter fornyes abonnementet til full pris på %{yearly_amount} / %{billing_period}.',
    },
    modal: {
      title: '%{discount_amount} % rabatt på årlig Pro',
      subtitle: 'Rabattkode: %{coupon_code_name}',
      text_content:
        'Det er det hele. Det er tilbudet. Vi gir deg %{discount_amount} % rabatt på ett år med Pro-abonnementet.',
      argument: {
        size_limit: 'Send og motta filoverføringer på 200 GB',
        storage_size: 'Benytt deg av en lagringskapasitet på 1 TB',
        unlimited_review: 'Opprett ubegrenset med gjennomganger',
      },
      cta_label: 'Få rabatt',
      dismiss_label: 'Ikke nå',
    },
    banner: {
      title:
        'Få %{discount_amount} % rabatt på WeTransfer Pro i ett år – vårt hittil beste tilbud',
      cta_label: 'Oppgrader',
    },
    pricing_page: {
      pill_label: '%{coupon_code_name} – %{discount_amount}% off',
    },
  },
  drawer: {
    first_viewing: {
      title:
        'Slå deg sammen med andre på overføringer med %{first_recipient_email}',
      subtitle:
        'Inviter teamet ditt til å sende og motta overføringer på %{user_plan}-pakken din.',
      list: {
        overview_item: 'Felles oversikt over overføringer',
        storage_limit_item:
          'Felles lagringskapasitet på %{storage_limit} ekstra per person',
        branding_item: 'Felles team-varemerking',
        subscription_item: 'Felles abonnement og fakturering',
      },
      cta: 'Inviter team',
      dismiss_button: 'Ikke i dag',
    },
    second_viewing: {
      title:
        'Slå deg sammen med andre på overføringer med ${first_recipient_email}',
      subtitle:
        'Inviter teamet ditt til å sende og motta overføringer på %{user_plan}-pakken din.',
      list: {
        overview_item: 'Felles oversikt over overføringer',
        storage_limit_item:
          'Felles lagringskapasitet på %{storage_limit} ekstra per person',
        branding_item: 'Felles team-varemerking',
        subscription_item: 'Felles abonnement og fakturering',
      },
      cta: 'Inviter team',
      dismiss_button: 'Skjul for alltid',
    },
  },
  external_links: {
    android_app: 'https://we.tl/android',
    ios_app: 'https://we.tl/iosapp',
    facebook: 'https://www.facebook.com/wetransfer',
    homerun: 'https://wetransfer.com/jobs',
    instagram: 'https://www.instagram.com/WeTransfer/',
    twitter: 'https://twitter.com/WeTransfer',
    prco: 'https://wetransfer.pr.co',
    youtube: 'https://www.youtube.com/WeTransfer',
  },
  notification: {
    update_account: 'Kontoen ble oppdatert',
    update_password: 'Passordet ble oppdatert',
    update_subscription: 'Betalingsplanen ble oppdatert',
    update_profile_success: 'Profilen ble oppdatert',
    link_copied: 'Koblingen er kopiert til utklippstavlen din',
    copy_link_manual: 'Koblingen er valgt – kopier den med %{shortcut}',
    delete_transfer_success: 'Overføringen ble slettet',
    delete_transfers_success: 'Overføringene ble slettet',
    update_expiry_success: 'Utløpsdatoen ble oppdatert',
    onboarding_success:
      'Kom hit, så finner du overføringsoversikten, kontakter, profilinnstillinger og andre ting og tang',
    add_contact_success: 'Kontakten ble lagt til',
    edit_contact_success: 'Kontakten ble oppdatert',
    remove_contact_success: 'Kontakten ble slettet',
    already_signed_in: 'Du er nå logget inn',
    cancel_subscription_success:
      'Det er leit å se at du forlater oss. Abonnementet ditt har blitt avbrutt.',
    collect_app_banner_desc:
      'Forhåndsvis, lagre og administrere filer fra Collect App',
    contact_added_confirmation: 'Kontakt lagt til i overføringen',
    contact_recipient_locked_text:
      'Denne siden er for at eieren skal kunne motta filer. Sender du til en annen?',
    forward_ready: 'Overføringen er klar til å videresendes',
    mobile_app_banner_desc: 'Vise, lagre og administrere filer fra appen',
    mobile_app_banner_title: 'Lagre det i appen',
    reactivate_subscription_success:
      'Velkommen tilbake! Kontoen din har blitt reaktivert. ',
    refresh_transfer_upload_lost:
      'Er du sikker på at du ønsker å avbryte den aktuelle opplastingen?',
    update_payment_success:
      'Betalingsinformasjonen din ble oppdatert. Fiks ferdig.',
    update_user: 'Opplysningene dine er oppdatert',
    current_team_notification: 'Du bruker %{plan} som %{currentTeam}',
    display_name_updated: 'Tittel oppdatert!',
    download_started:
      'Nedlastingen har startet. Når den er ferdig, er filene kommet på datamaskinen din (ofte i nedlastingsmappen).',
    logged_out:
      'Ser ut til at du har blitt logget ut fra en annen nettleser. Logg inn igjen.',
    project_delete:
      'Vil du slette <strong>%{projectName}</strong> og alle filer du har lagt til i det?',
    project_delete_success: '<strong>%{projectName}</strong> er slettet',
    password_changed: 'Passordet er endret',
    password_removed: 'Passord fjernet',
  },
  alert: {
    confirm_cancel_upload_image:
      'Er du sikker på at du ønsker å avbryte den aktuelle opplastingen? ',
    cancel_recipient_locked: 'Avbryt',
    cancel_refresh_transfer_upload_lost: 'Nei',
    confirm_refresh_transfer_upload_lost: 'Ja',
    go_to_transfer: 'Gå til overføring',
    redirect_recipient_locked: 'Ja',
    stay: 'Bli værende',
    cancel_project_delete: 'Avbryt',
    confirm_project_delete: 'Slett',
  },
  force_update:
    'Du har spennende ting i vente! <a href="/" onClick=\'javascript:window.location.reload();\'>Last inn nettleseren på nytt</a> for å sikre at du bruker den nyeste versjonen av WeTransfer.',
  user: {
    already_logged_in:
      'Du er allerede pålogget. Er du sikker på at du ønsker å tilbakestille passordet?',
    roles: {
      admin: 'administrator',
      owner: 'eier',
      user: 'bruker',
    },
    sign_out_and_reset: 'Logg ut og tilbakestill passordet',
  },
  click_here: 'Klikk her',
  cookiebox: {
    notice:
      '<bold>For øyeblikket er du logget på</bold>, men du blir logget av etter at informasjonskapslene dine er fjernet. Tidligere overføringer i kontoen din blir ikke berørt.',
  },
  notice: {
    general_issues:
      'Virker ikke alt som det skal? Vi vet det er frustrerende, men bare vent – vi får alt på stell igjen <a target="_blank" href=%{link}>så snart som mulig</a>',
    transfer_issues:
      'Har du problemer med overføringen din? Vi vet det er frustrerende, men bare vent – vi får alt på stell igjen <a target="_blank" href=%{link}>så snart som mulig</a>',
    verification:
      'Hei, vi må ha deg til å <a href="/account">bekrefte e-postadressen din</a>',
  },
  site: {
    name: 'WeTransfer',
    titles: {
      about: 'Om | WeTransfer',
      advertise: 'Annonser hos oss | WeTransfer',
      apps: 'Gratisapper for Mac, iOS og Android | WeTransfer-apper',
      forgot_password: 'Tilbakestill passordet ditt | WeTransfer Pro',
      help: 'Hvordan sende store filer | WeTransfer hjelp',
      home: 'Del store filer enkelt og gratis | WeTransfer',
      plus: 'Oppgrader for å sende større filer | WeTransfer Pro',
      sign_in: 'Logg på | WeTransfer Pro',
      sign_up: 'Registrer deg | WeTransfer Pro',
      upgrade: 'Oppgrader | WeTransfer Pro',
      pricing:
        'Priser | WeTransfer – Send store filer og del bilder på nettet – opptil 2 GB gratis',
    },
    descriptions: {
      help: 'Need WeTransfer tech support? Find out how to send large files in our Quick Help section or get in touch.',
      social_help: 'Har du ennå ikke funnet det du leter etter?',
    },
  },
  splash: {
    footer: {
      or: 'eller',
      send_files: 'Jeg vil bare sende filene mine',
      no_thanks: 'Nei takk',
    },
    heading: {
      line_1_free: 'WeTransfer er den beste måten å sende store filer på',
      line_2_free: 'Få mer ut av WeTransfer',
      free_account: 'Velkommen tilbake. Skal vi ta dette til neste nivå?',
    },
    plan: {
      plus: {
        feature_10: 'Tilpass e-postene dine',
        feature_11: 'Lagre opptil %{plus_storage_limit}',
        feature_12: 'Bestem selv når overføringene utløper',
        feature_13: 'Beskytt overføringene dine med passord',
        feature_7: 'Tilpass profilen din',
        feature_8: 'Opprett din egen adressebok',
        feature_9: 'Tilpass din egen WeTransfer-URL',
      },
      free_account: {
        cta: 'Registrer deg gratis',
        feature_1: 'Ingen lagring',
        feature_2: 'Send opptil %{free_transfer_limit}',
        feature_3: 'Send på nytt og slett overføringer',
        heading: 'WeTransfer-konto',
        price_label: 'Gratis i all evighet',
      },
      pro: {
        cta: 'Få WeTransfer Pro',
        feature_1: '%{storage_limit_pro} lagringsplass',
        feature_2: 'Send og motta opptil %{transfer_limit_pro}',
        feature_2_unlimited: 'Send og motta filer uten størrelsesbegrensninger',
        feature_3: 'Send på nytt og slett overføringer',
        feature_4: 'Passordbeskytt overføringer',
        feature_5: 'Din egen Pro-side og URL',
        heading: 'WeTransfer',
      },
    },
  },
  tooltip: {
    team_discovery: {
      title: 'Vil du legge til %{recipient} i teamet ditt?',
      text_content:
        'Teammedlemmer har tilgang til hverandres overføringer med felles lagringskapasitet og varemerking. Dette avbryter ikke overføringen din.',
      cta: 'Kom igjen!',
    },
  },
  transfer_link: {
    buttons: {
      copied: 'Kobling kopiert',
      copy: 'Kopier kobling',
      copy_again: 'Kopier på nytt',
    },
    labels: {
      share: 'Del denne overføringen',
    },
  },
  callout: {
    pill: {
      pro_onboarding: 'PROFFTIPS',
    },
    'portals-onboarding': {
      'first-viewing': {
        cta: 'Prøv portaler',
        dismiss: 'Ikke nå',
        text: 'Du kan invitere klienter og samarbeidspartnere til å se arbeidet ditt og velge favoritter med <strong>portaler</strong>. Heia for mindre utveksling av e-post!',
        title: 'Trenger du tilbakemelding på arbeidet ditt – skikkelig kjapt?',
      },
      'second-viewing': {
        cta: 'Prøv portaler nå',
        dismiss: 'Ikke vis dette igjen',
        text: 'Få rask tilbakemelding og del nye versjoner – alt på ett sted. <strong>portaler</strong> lar deg fortsette å jobbe smidig fra gjennomgang til nytt utkast og videre, helt til siste avsendelse.',
        title: 'Du har sendt arbeidet. Hva nå?',
      },
    },
    pro_onboarding: {
      admin: {
        cta: 'Gå til Varemerking',
        text_2: 'Lyst til å legge til dine egne videoer eller bilder?',
      },
      individual: {
        cta: 'Konfigurer side',
        text: 'Gjør et strålende inntrykk hver gang noen laster ned filene dine—legg til videoer eller bilder og velg din egen URL-adresse.',
        title: 'Sett stemingen med din egen WeTransfer-side',
      },
      invitee: {
        cta: 'Skjønner',
        text_1:
          'Teamets tilpassede WeTransfer-side lar dere gjøre et glimrende inntrykk hver gang dere deler arbeidet deres.',
        text_2:
          'Du kan når som helst endre teamets bakgrunnsbilde i <strong>Varemerking</strong>.',
        title: 'Vis frem (sam)arbeidet',
      },
      not_now: 'Ikke nå',
    },
  },
  cue: {
    inline: {
      teams: {
        onboarding: {
          transfers: {
            received: {
              mini: {
                branding_incomplete: {
                  cta: 'Konfigurer side',
                  premium: {
                    text: 'Alle kan sende dere overføringer av alle størrelse fra teamets WeTransfer-side.',
                  },
                  text: 'Alle kan sende dere overføringer på %{transfer_limit_pro} fra teamets WeTransfer-side.',
                },
                premium: {
                  transfer_link: {
                    text: 'Alle kan sende deg overføringer av alle størrelser fra %{custom_link}',
                  },
                },
                transfer_link: {
                  text: 'Alle kan sende dere overføringer på opptil %{transfer_limit_pro} fra %{custom_link}',
                },
              },
              premium: {
                text: 'Alle kan sende dere overføringer av alle størrelse fra teamets WeTransfer-side—bare gi dem denne koblingen.',
              },
              regular: {
                cta: 'Skjønner',
                text: 'Alle kan sende dere overføringer på <strong>%{transfer_limit_pro}</strong> fra teamets WeTransfer-side. Bare gi dem koblingen.',
                title: 'Ett sted for alt teamet ditt mottar',
              },
            },
            sent: {
              regular: {
                cta: 'Skjønner',
                text: 'Velkommen til den delte oversikten over teamets sendte overføringer. Du kan spore nedlastinger, endre utløpstfrister og til og med redigere eller slette andres overføringer – men det er kanskje pent å si fra til dem først!',
                title: 'Administrer teamets overføringer',
              },
            },
          },
        },
      },
    },
  },
  feature_banner: {
    pro: 'WeTransfer Plus heter nå WeTransfer Pro, med 1 TB lagringsplass — det er 10x mer. <a href="/transfers">Sjekk det ut.</a>',
  },
  refer_friend: {
    title: 'Verv venner',
    account: {
      description:
        'Vi gir deg og en venn $ 10 hver når vennen registrerer seg for WeTransfer Pro eller Premium. Del henvisningslenken for å få belønninger i form av forhåndsbetalte kort, donasjoner til veldedige formål eller gavekort fra hundrevis av partnere.',
    },
    window: {
      link: 'Få en henvisningslenke',
      send_another: 'Fortsett',
      text: 'Vi gir deg og en venn <strong>$ 10</strong> hver når vennen registrerer seg for WeTransfer Pro eller Premium.',
      title: 'Verv en venn',
      title_2: 'for å sende overføringer.',
    },
    message: {
      success:
        'Du har en god venn her! Registrer deg for WeTransfer Pro eller Premium, så får dere begge et forhåndsbetalt kort, en donasjon til et veldedig formål eller et gavekort verdt $ 10.',
      self: 'Å nei, den henvisningslenken ser ikke riktig ut. Be vennen din om å få en ny lenke for å motta $ 10 når du registrerer deg for WeTransfer Pro eller Premium.',
      fallback:
        'Å nei, den henvisningslenken ser ikke riktig ut. Be vennen din om å få en ny lenke for å motta $ 10 når du registrerer deg for WeTransfer Pro eller Premium.',
      expired: 'Beklager, henvisningslenken er utløpt.',
      dismiss: 'Lukk',
    },
  },
  order_summary: {
    coupon: {
      link: 'Bruk kampanjekoden',
      input_placeholder: 'Kampanjekode',
      button_label: 'Bruk',
      error_message:
        'Beklager, denne koden kan bare brukes til å spare på et %{billing_period}-abonnement.',
      generic_error_message:
        'Beklager, denne koden er ikke kompatibel for dette abonnementet',
      input_error_message: 'Hmm, dette er ikke en gyldig kode.',
      pill_label: {
        percentage: '-%{percentage} %',
      },
    },
    total: 'Totalt',
  },
  mobile_verify: {
    title: 'Alt er klart',
    subtitle:
      'E-postadressen din er bekreftet – du kan nå bruke appen til å sende og motta overføringer.',
    cta: 'Åpne WeTransfer-appen',
  },
  pricing_panel: {
    current_solo_workspace_information:
      'Din nåværende pakke til <b>%{formattedintervaltotal}</b> per %{subscriptioninterval} fornyes automatisk <b>%{autorenewalattempt}</b>',
    current_team_workspace_information:
      'Din nåværende pakke til <b>%{formattedTeamWorkspaceCost}</b> per %{subscriptioninterval} (%{membercount} x %{tieramount}) fornyes automatisk <b>%{autorenewalattempt}</b>',
    next_payment_date:
      'Neste betalingsdato er <b>%{recurring_billing_date}</b>',
    upgrade_price: '<b>%{totalprice}</b> per %{interval}',
    team_upgrade_calculation: '(%{membercount} medlemmer x %{tierprice})',
    premium_title: 'WeTransfer Premium',
    premium_feature_one: 'Ingen størrelsesbegrensninger på overføringer',
    premium_feature_two: 'Ubegrenset lagringskapasitet',
    premium_feature_three: 'ubegrenset antall portaler og gjennomganger',
    premium_feature_four:
      'Se <a class="all-benefits-link" href="%{all_benefits_href}">alle fordelene</a>',
    premium_switch_cta_text: 'Bytt til Premium',
    pill_text: 'Gjeldende abonnement',
    member_count: '%{membercount} medlemmer',
    see_all_benefits: 'Se alle fordelene i planen',
    pending_downgrade_current_subscription:
      'Abonnementet på arbeidsområdet ditt er avsluttet og utløper <b>%{cancellation_date}</b>.',
    pending_downgrade_reactivate_text:
      'Har du ombestemt deg? Ingen grunn til panikk – det er lett å komme i gang igjen.',
    pending_downgrade_reactivate_cta: 'Reaktiver Pro',
    pending_downgrade_payment: 'Du har ingen kommende betalinger',
    update_payment_cta: 'Oppdater betalingsinformasjon',
    cancel_plan:
      'Hvis du sier opp abonnementet, har du tilgang til %{planName}-arbeidsområdet til %{subscriptionRenewalDate}. ',
    cancel_expiry_text:
      'Arbeidsområdet blir da nedgradert til gratispakken, og de eksisterende overføringene dine utløper etter 28 dager.',
    pending_payment_text:
      'For å se abonnementet ditt og betalingsinformasjonen må du fullføre betalingen eller kansellere bestillingen.',
    learn_more: 'Finn ut mer om abonnementer og priser',
  },
  time: {
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    remaining: {
      minutes: {
        zero: 'Under a minute remaining',
        one: 'About 1 minute remaining',
        other: 'About %{count} minutes remaining',
      },
      hours: {
        one: 'About an hour remaining',
        other: 'About %{count} hours remaining',
      },
    },
  },
  download: {
    shortcut: 'Press %{command} to see the<br />download progress',
    shortcuts: {
      control_j: 'Ctrl-J',
      control_alt_l: 'Ctrl-Alt-L',
      cmd_shift_j: '&#8984;-Shift-J',
      cmd_j: '&#8984;-J',
      cmd_alt_l: '&#8984;-Alt-L',
    },
  },
  upload: {
    title: 'Send up to %{size}',
    progress: {
      busy: 'Transferring...',
    },
    buttons: {
      add: 'Add files',
      transfer: 'Transfer',
      forward: 'Forward',
    },
    forward: {
      done: 'Forward complete',
    },
    friend_email: {
      title: "Friend's email",
      more: 'Add more friends',
    },
    your_email: {
      title: 'Your email',
    },
    message: {
      title: 'Message',
    },
    done: {
      title: 'Transfer complete',
      link: 'Copy your download link:',
      copied: {
        title: 'Copied!',
        text: 'The download link has been copied.',
      },
    },
    more_html: 'Add more files<span>(%{size} left)</span>',
    too_many_recipients:
      "Seems like you've entered too many email addresses. Remember: there's room for up to %{count} people at a time.",
    completed: '%{size} of %{total} completed',
    addresses: {
      one: '%{count} address',
      other: '%{count} addresses',
      remove: 'Do you want to remove %{address} from your previous recipients?',
    },
    ads: {
      plus: {
        title: 'Get more out<br />of WeTransfer<br />with Pro',
        text: "<ul><li>Supersized uploads</li><li>Personalised transfers with your own backgrounds</li><li>Password protected transfers</li><li>Long term storage</li></ul><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus2: {
        title: 'Impress<br />with your<br />own custom download page',
        text: "<p>Use your own backgrounds and custom WeTransfer URL (yourname.wetransfer.com)<br />to impress your recipients.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus3: {
        title: 'Manage<br />your transfers smarter',
        text: "<p>This transfer is deleted after a week, but with WeTransfer Pro you can store indefinitely, resend and delete instantly, without having to upload again.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      plus4: {
        title: 'Get extra protection<br />for your files',
        text: "<p>With WeTransfer Pro, you can protect your important and confidential files with a password.</p><p>That way they will never fall into the wrong hands.</p><p><a target='_blank' href='/pro?trk=inapp'>Find out more</a></p>",
      },
      facebook: {
        title: 'Join the<br />WeTransfer<br />community<br />on Facebook',
        text: "<p>Get the latest news, win prizes, discover new artists, read interviews and much more.</p><p><a target='_blank' href='https://www.facebook.com/wetransfer'>Find out more</a></p>",
      },
      flipflops: {
        title: 'Free flipflops by WeTransfer',
        text: "<p style='text-align:center;'><img src='/assets/flipflops.jpg'></p><p>As a thank you from us, we've teamed up with Suavesoles to get you this fantastic pair of flipflops for free!<br /><a target='_blank' href='http://suavesoles.com/we-transfer/?ref=wt-app'>Order now</a></p>",
      },
    },
    errors: {
      only_email: 'Sorry, only email is supported when resending a transfer.',
      connect_twitter:
        'Your Twitter account is not yet connected to WeTransfer.',
      connect_facebook:
        'Your Facebook account is not yet connected to WeTransfer.',
      transferproblems: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      limitreached: {
        title: 'Storage Limit',
        text: 'You reached your 1 TB limit. Delete some old transfers to send new files',
      },
      blocked: {
        title: 'Transfer problem',
        text: 'Computer says no. Sorry, but you have been blocked from WeTransfer.',
      },
      upload_error: {
        title: 'Transfer problem',
        text: 'Hate to break it to you, but something went wrong with the transfer.',
      },
      unavailable: {
        title: 'Transfer error',
        text: 'Sorry, this transfer has already been deleted so it cannot be forwarded.',
      },
      startswithdot: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a full stop. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      startswithspace: {
        title: 'Oops',
        text: "One (or more) of your files has a name that starts with a space. That's not going to work. Please rename the file(s), and try adding them again.",
      },
      containsreturn: {
        title: 'Oops',
        text: "One (or more) of your files has a name that contains a return. We don't know quite how you've done that, but it's not going to work. Please rename the file(s), and try adding them again.",
      },
      alreadyinlist: {
        title: 'Yikes',
        text: "Turns out one of your files had the same name as another file that you've already selected. Change it up a little!",
      },
      transfertoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      filetoobig: {
        title: 'Uh-oh',
        text: "Ever so sorry, but we can't transfer more than %{upload_limit}GB at a time.",
      },
      zerobytes: {
        title: 'Whoops',
        text: 'One (or more) of your files is empty or could not be read.',
      },
      ioerror: {
        title: 'Fail',
        text: "One (or more) of your files could not be read or is larger than %{upload_limit}GB. That's not going to fly.",
      },
      filenametoolong: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that is longer than 250 characters. We can't accept filenames longer than this, so please rename it.",
      },
      nofolders: {
        title: 'Uh-oh',
        text: "Sorry, uploading folders doesn't work yet. Try zipping it first.",
      },
      nofiles: {
        title: 'Oops',
        text: "You haven't actually added any files yet.",
      },
      norecipients: {
        title: 'Doh!',
        text: 'Looks like you forgot to enter any email addresses to send to.',
      },
      toomanyrecipients: {
        title: 'Yikes',
        text: 'Too many recipients.',
      },
      bigmessage: {
        title: 'Oops',
        text: 'Your message is longer than a novel. Please make it shorter.',
      },
      nosender: {
        title: 'Seriously?',
        text: 'You forgot to enter your own email address. How could you?',
      },
      senderemailinvalidformat: {
        title: 'Uh-oh',
        text: 'Your email address appears to be incorrect. Mind your spelling!',
      },
      probablynotcopied: {
        title: 'Oops',
        text: "It looks like you haven't copied the link.",
      },
      recipientemailinvalidformat: {
        title: 'Oops',
        text: "You entered one of your friend's email addresses incorrectly.",
      },
      requiresdefaultrecipient: {
        title: 'Uh-oh',
        text: 'Sorry! You can only send more than 2GB to the Pro Channel owner. Refresh the page to start again.',
      },
      containsbackslash: {
        title: 'Yikes',
        text: "One (or more) of your files has a filename that contains a backslash. We can't accept this, so please rename the files so they don't contain the backslash.",
      },
    },
    tips: {
      maxfilesize_tip: {
        title: 'Tip',
        text: "You can send up to 2GB per transfer. And what's even better: you can transfer as often as you like.",
      },
      maxfilesize_oldbrowser_tip: {
        title: 'Important',
        text: "Your Pro account can send up to 20 GB per transfer, but your browser is preventing this. <a href='/questions/33'>Click here for more information</a>",
      },
      recipients_tip: {
        title: 'Tip',
        text: 'You can enter up to %{email_limit} email addresses to send to. If you just want a download link, click on the share button below.',
      },
      default_recipient: {
        title: 'Tip',
        text: 'To send over 2GB, make sure you upload your files to the Pro Channel owner only. Refreshing the page will pre-fill their address for you.',
      },
      sender_tip: {
        title: 'Tip',
        text: 'Pop your own email address in here so we can contact you when the files have been downloaded.',
      },
      expire_tip: {
        title: 'Tip',
        text: 'You can now change the expiry date of your Pro transfers.',
      },
      message_tip: {
        title: 'Tip',
        text: "Want to send your friends a message along with the files? Here's your chance - but you don’t have to.",
      },
      share_tip: {
        title: 'Tip',
        text: 'Change the way you share your files. Send them by email or grab a download link.',
        text_plus:
          'Change the way you share your files. Send them by email, Twitter, Facebook, or grab a download link.',
      },
      download: {
        title: '',
        chrome:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The download progress should be visible at the bottom of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out how to change this behaviour here</a>.",
        firefox:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in your browser's Download window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        safari:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible in the top right corner of your browser window, and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        old_explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. You may also see a security alert at the top of the browser window. <a href='/questions/24' target='_blank'>Find out more</a>.",
        explorer:
          "Downloading works differently from before. We are now downloading all files through the browser, so you will no longer see the progress in WeTransfer, and you may not be asked where to store the file. The progress should be visible at the bottom of your browser window (you may need to click on Save first), and your file will be stored by default in your Downloads folder. <a href='/questions/24' target='_blank'>Find out more</a>.",
        settings:
          'You can change your default download location in your browser settings.',
      },
    },
  },
  warnings: {
    unsaved_changed:
      'You have made changes to your Channel. Are you sure you want to leave this page without saving?',
    forwarding: 'Forwarding this transfer will clear the form, are you sure?',
    is_busy: "Sorry, we can't do this right now",
  },
  mobile_app: {
    remember_choice: "Don't show this message again",
    uploader: {
      description:
        'Our site is not optimised for mobile right now. But we do have a shiny mobile app.',
      app_name: 'WeTransfer',
      download: 'Download the App',
      continue: 'Continue to WeTransfer.com',
    },
    downloader: {
      title: 'Your files are ready for download!',
      description_ios:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://itunes.apple.com/us/app/winzip/id500637987?mt=8">Winzip</a>" is a pretty good app for that.',
      description_android:
        'We\'ve bundled your files in a zip file. You will need an app to extract and view the files. We think "<a href="https://play.google.com/store/apps/details?id=com.estrongs.android.pop&hl=en">ES File Explorer</a>" is a pretty good app for that.',
      continue: 'Understood',
    },
  },
};
